export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSONSTRING: { input: any; output: any; }
};

export enum AiInsightVerdict {
  LikelyBenign = 'LIKELY_BENIGN',
  LikelyMalicious = 'LIKELY_MALICIOUS',
  Suspicious = 'SUSPICIOUS',
  Undetermined = 'UNDETERMINED'
}

export type AiInsights = {
  __typename?: 'AIInsights';
  ai_insight_report_id?: Maybe<Scalars['String']['output']>;
  ai_insight_verdict?: Maybe<AiInsightVerdict>;
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyDefinition = {
  __typename?: 'APIKeyDefinition';
  api_key?: Maybe<Scalars['String']['output']>;
  api_key_definition_id?: Maybe<Scalars['String']['output']>;
  created_by_alias?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  end_ts?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_ts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  updated_by_alias?: Maybe<Scalars['String']['output']>;
  updated_ts?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Alert = {
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  score?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenant: Scalars['String']['output'];
};

export type AlertAndDetectionTenantInfo = {
  __typename?: 'AlertAndDetectionTenantInfo';
  tenant_display_name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

export type AlertDisposition = {
  __typename?: 'AlertDisposition';
  comments?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<AlertDispositionStatus>;
  set_by?: Maybe<Scalars['String']['output']>;
  set_by_alias?: Maybe<Scalars['String']['output']>;
  set_timestamp?: Maybe<Scalars['Float']['output']>;
};

export enum AlertDispositionStatus {
  Accurate = 'ACCURATE',
  Inaccurate = 'INACCURATE'
}

export type AlertDocumentation = {
  __typename?: 'AlertDocumentation';
  nextsteps?: Maybe<Scalars['String']['output']>;
  queries?: Maybe<Scalars['String']['output']>;
  significance?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Scalars['String']['output']>;
};

export type AlertEntity = {
  __typename?: 'AlertEntity';
  entity_category?: Maybe<EntityCategory>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_locality?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
};

export type AlertEntityInfoInput = {
  entity_name?: InputMaybe<Scalars['String']['input']>;
  entity_type?: InputMaybe<EntityDataStoreAlertEntityType>;
};

export enum AlertEntityType {
  Domain = 'DOMAIN',
  Host = 'HOST',
  Ip = 'IP',
  IpRange = 'IP_RANGE',
  Mac = 'MAC',
  User = 'USER'
}

export enum AlertField {
  SourceIp = 'source_ip',
  Xff = 'xff'
}

export type AlertInfo = {
  __typename?: 'AlertInfo';
  alert_name?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
};

export type AlertKeys = {
  __typename?: 'AlertKeys';
  tenant_alert?: Maybe<Scalars['String']['output']>;
  tenant_alert_entity?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
};

export type AlertMetadata = {
  __typename?: 'AlertMetadata';
  _score?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  alert_next_steps?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  category_tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  chatbot_chats?: Maybe<AlertMetadataChatbotChats>;
  content_doc?: Maybe<AlertDocumentation>;
  content_id?: Maybe<Scalars['String']['output']>;
  custom_search_rule?: Maybe<CustomSearchRuleAlertMetadata>;
  cve_reference?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity_allowedlist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  event_generation_strategy?: Maybe<MetadataEventStrategy>;
  excluded_entities?: Maybe<Array<Maybe<ExcludedEntity>>>;
  falsepositives?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  logsource?: Maybe<MetadataLogSource>;
  managed_by?: Maybe<ManagedBy>;
  match_meta?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_mappings?: Maybe<MitreMappings>;
  pivot_query?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related?: Maybe<Array<Maybe<MetadataRelated>>>;
  rule?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  severity_description?: Maybe<Scalars['String']['output']>;
  severity_info?: Maybe<SeverityInfo>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_alert?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_alias?: Maybe<Scalars['String']['output']>;
  updated_timestamp?: Maybe<Scalars['Float']['output']>;
};

export type AlertMetadataChatbotChats = {
  __typename?: 'AlertMetadataChatbotChats';
  non_suri_alert_attack?: Maybe<Scalars['String']['output']>;
  non_suri_alert_ttp?: Maybe<Scalars['String']['output']>;
  suri_alert_explain?: Maybe<Scalars['String']['output']>;
  suri_describe_rule?: Maybe<Scalars['String']['output']>;
  suri_investigate_alert?: Maybe<Scalars['String']['output']>;
};

export type AlertMetadataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alert_name: Scalars['String']['input'];
  alert_type: Scalars['String']['input'];
  content_id: Scalars['String']['input'];
  excluded_entities?: InputMaybe<Array<InputMaybe<ExcludedEntityInput>>>;
  tenant: Scalars['String']['input'];
  updated_timestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type AlertNameFilterInput = {
  alert_name?: InputMaybe<Scalars['String']['input']>;
  detection_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AlertSessionSummary = {
  __typename?: 'AlertSessionSummary';
  alert_beacons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alert_summary?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attack_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ioc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unusual_findings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AlertTimestamp = {
  __typename?: 'AlertTimestamp';
  end?: Maybe<Scalars['Float']['output']>;
  observed?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  ttl?: Maybe<Scalars['Float']['output']>;
};

export type AlgorithmParameters = {
  __typename?: 'AlgorithmParameters';
  algorithm?: Maybe<Scalars['String']['output']>;
  compute_norm_values?: Maybe<Scalars['Boolean']['output']>;
  data_strategy?: Maybe<Scalars['String']['output']>;
  eliminate_outliers?: Maybe<Scalars['Boolean']['output']>;
  label_threshold?: Maybe<Scalars['Int']['output']>;
  learners?: Maybe<Scalars['Int']['output']>;
  remove_correlated?: Maybe<Scalars['Float']['output']>;
  remove_sparse?: Maybe<Scalars['Boolean']['output']>;
  tune_training_set?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalysisSummary = {
  __typename?: 'AnalysisSummary';
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  verdict?: Maybe<Verdict>;
};

export type AnomalyAlert = Alert & {
  __typename?: 'AnomalyAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  anomaly_type?: Maybe<Scalars['String']['output']>;
  baselining_end_timestamp?: Maybe<Scalars['Float']['output']>;
  baselining_start_timestamp?: Maybe<Scalars['Float']['output']>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  destination_ip?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  entity_training_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  history?: Maybe<Scalars['Float']['output']>;
  history_days?: Maybe<Scalars['Int']['output']>;
  ignorable?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
  item_assoc_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_assoc_entities_similarity?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  item_score?: Maybe<Scalars['Float']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn1_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn1_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn1_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn1_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn2_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn2_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn2_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn2_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn3_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn3_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn3_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn3_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn4_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn4_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn4_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn4_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn5_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn5_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn5_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn5_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn6_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn6_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn6_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn6_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn7_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn7_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn7_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn7_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn8_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn8_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn8_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn8_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn9_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn9_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn9_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn9_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn10_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn10_entity_similarity?: Maybe<Scalars['Float']['output']>;
  nn10_pred_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nn10_train_items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orig_h?: Maybe<Scalars['String']['output']>;
  original_entity?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  score?: Maybe<Scalars['Float']['output']>;
  session_summary?: Maybe<AlertSessionSummary>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_ip?: Maybe<Scalars['String']['output']>;
  system_name?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  uid?: Maybe<Scalars['String']['output']>;
  usecase?: Maybe<Scalars['String']['output']>;
  usecase_description?: Maybe<Scalars['String']['output']>;
};


export type AnomalyAlertSessionSummaryArgs = {
  log_search_client_session_id: Scalars['String']['input'];
};

export type AroundInput = {
  eventId: Scalars['String']['input'];
  numberOfEventsAfter: Scalars['Int']['input'];
  numberOfEventsBefore: Scalars['Int']['input'];
  timestamp: Scalars['Int']['input'];
};

export type AssessmentStep = {
  __typename?: 'AssessmentStep';
  step_name?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type AssignDetectionsInput = {
  assignment_info: DetectionAssignmentInfoInput;
  detection_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  update_info: DetectionUpdateInfoInput;
};

export type BlogOutput = {
  __typename?: 'BlogOutput';
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dc_creator?: Maybe<Scalars['String']['output']>;
  dc_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  pub_date?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BulkCommentInput = {
  /** The detection ids, each of which will have a comment created for it. */
  detection_ids: Array<Scalars['String']['input']>;
  /** The comment string. */
  input_comment: Scalars['String']['input'];
  /**
   * The tenants that own the detections for which the detection_ids point to.
   * If not passed in, the logged in user tenant will be used instead.
   */
  tenants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkCommentsOperationResult = {
  __typename?: 'BulkCommentsOperationResult';
  message?: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  alert_name?: Maybe<Scalars['String']['output']>;
  author_alias?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comment_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Float']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CommentParent>;
  replies?: Maybe<PaginatedComments>;
  severity?: Maybe<Scalars['Int']['output']>;
  tenant: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Float']['output']>;
};


export type CommentRepliesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CommentSortParameterInput>>>;
};

export type CommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CommentParentInput>;
  tenant: Scalars['String']['input'];
};

export type CommentParent = {
  __typename?: 'CommentParent';
  parent_object_id?: Maybe<Scalars['String']['output']>;
  parent_object_type?: Maybe<CommentParentType>;
};

export type CommentParentInput = {
  parent_object_id?: InputMaybe<Scalars['String']['input']>;
  parent_object_type?: InputMaybe<CommentParentType>;
};

export enum CommentParentType {
  Alert = 'alert',
  Comment = 'comment',
  Detection = 'detection'
}

export enum CommentSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type CommentSortParameter = {
  __typename?: 'CommentSortParameter';
  direction?: Maybe<CommentSortDirection>;
  field?: Maybe<Scalars['String']['output']>;
};

export type CommentSortParameterInput = {
  direction?: InputMaybe<CommentSortDirection>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type CompromisedEntity = {
  __typename?: 'CompromisedEntity';
  entity_id?: Maybe<Scalars['String']['output']>;
  primary_display_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConfigInfo = {
  __typename?: 'ConfigInfo';
  config_key?: Maybe<Scalars['String']['output']>;
  config_value?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigResponse = {
  __typename?: 'ConfigResponse';
  category?: Maybe<Scalars['String']['output']>;
  configs?: Maybe<Array<Maybe<ConfigInfo>>>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type ConfiguredSensorOutput = {
  __typename?: 'ConfiguredSensorOutput';
  configured?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsolidatedEntityTriageReport = {
  __typename?: 'ConsolidatedEntityTriageReport';
  analysis_summary?: Maybe<AnalysisSummary>;
  created_at?: Maybe<Scalars['Float']['output']>;
  detections_info?: Maybe<DetectionsInfo>;
  entity_id: Scalars['String']['output'];
  entity_info?: Maybe<EntityInfo>;
  investigation_end_timestamp?: Maybe<Scalars['Float']['output']>;
  investigation_id: Scalars['String']['output'];
  investigation_start_timestamp?: Maybe<Scalars['Float']['output']>;
  key_findings_info?: Maybe<KeyFindingsInfo>;
  playbook?: Maybe<Playbook>;
  recommended_actions_info?: Maybe<RecommendedActionsInfo>;
  related_questions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  report_id: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
};

export enum CookieStatus {
  Accepted = 'ACCEPTED',
  Denied = 'DENIED'
}

export enum CookieType {
  Analytics = 'ANALYTICS',
  StrictlyNecessary = 'STRICTLY_NECESSARY'
}

export type CreateEntitySuppressionConfigurationInput = {
  fields_to_suppress: Array<AlertField>;
  file_content: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  reason_for_suppression: Scalars['String']['input'];
};

export type CreateQueryJobResult = {
  __typename?: 'CreateQueryJobResult';
  query_job_id?: Maybe<Scalars['String']['output']>;
};

export type CreateUserInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  group: Scalars['String']['input'];
  is_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  super_admin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrowdStrikeConfiguration = EdrConfiguration & {
  __typename?: 'CrowdStrikeConfiguration';
  base_url?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  edr_action_enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  polling_seconds?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<EdrConfigurationType>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type CrowdStrikeConfigurationInput = {
  base_url: Scalars['String']['input'];
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  edr_action_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  polling_seconds: Scalars['Int']['input'];
};

export type CrowdStrikeEndpointDevice = EdrEndpointDevice & {
  __typename?: 'CrowdStrikeEndpointDevice';
  data_source?: Maybe<EdrConfigurationType>;
  device_id?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_status?: Maybe<Scalars['String']['output']>;
  entity_status_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_type?: Maybe<EntityDataStoreEntityType>;
  expire_at?: Maybe<Scalars['Float']['output']>;
  host_info?: Maybe<CrowdStrikeHostInfo>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  nic_history?: Maybe<PaginatedNicHistory>;
  obsts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  user_history?: Maybe<PaginatedUserHistory>;
};

export type CrowdStrikeHostInfo = {
  __typename?: 'CrowdStrikeHostInfo';
  ad_domain_name?: Maybe<Scalars['String']['output']>;
  ad_organizational_unit_name?: Maybe<Scalars['String']['output']>;
  cloud_account_id?: Maybe<Scalars['String']['output']>;
  cloud_instance_id?: Maybe<Scalars['String']['output']>;
  cloud_provider?: Maybe<Scalars['String']['output']>;
  external_ip?: Maybe<Scalars['String']['output']>;
  host_name?: Maybe<Scalars['String']['output']>;
  local_ip?: Maybe<Scalars['String']['output']>;
  mac_address?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  platform_type?: Maybe<Scalars['String']['output']>;
  sensor_version?: Maybe<Scalars['String']['output']>;
};

export type CrowdStrikeIdentityUserInfo = {
  __typename?: 'CrowdStrikeIdentityUserInfo';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  identity_alerts_count?: Maybe<Scalars['Int']['output']>;
  risk_score?: Maybe<Scalars['Float']['output']>;
  risk_score_severity?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CrowdStrikeIncidentDetail = {
  __typename?: 'CrowdStrikeIncidentDetail';
  compromised_entities?: Maybe<Array<Maybe<CompromisedEntity>>>;
  end_time?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['Float']['output']>;
  timeline?: Maybe<Array<Maybe<TimelineEvent>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CurrentPreviousSummary = {
  __typename?: 'CurrentPreviousSummary';
  current?: Maybe<Scalars['Int']['output']>;
  pct_chg?: Maybe<Scalars['Float']['output']>;
  previous?: Maybe<Scalars['Int']['output']>;
};

export type CustomSearchRuleAlert = Alert & {
  __typename?: 'CustomSearchRuleAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  score?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenant: Scalars['String']['output'];
};

export type CustomSearchRuleAlertMetadata = {
  __typename?: 'CustomSearchRuleAlertMetadata';
  query_filter?: Maybe<Scalars['String']['output']>;
  query_string?: Maybe<Scalars['String']['output']>;
  throttle_time?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Detection = {
  __typename?: 'Detection';
  alert_entity: AlertEntity;
  alert_info: AlertInfo;
  assignment_info?: Maybe<DetectionAssignmentInfo>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  created_timestamp: Scalars['Float']['output'];
  detection_id: Scalars['String']['output'];
  detection_keys?: Maybe<DetectionKeys>;
  detection_method?: Maybe<Scalars['String']['output']>;
  detection_status: DetectionStatus;
  detection_timestamp: DetectionTimestamp;
  earliest_start_timestamp?: Maybe<Scalars['Float']['output']>;
  escalation_data?: Maybe<DetectionEscalationData>;
  latest_start_timestamp?: Maybe<Scalars['Float']['output']>;
  logscale_query?: Maybe<Scalars['String']['output']>;
  mitre_mappings?: Maybe<MitreMappings>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paginated_destination_entities?: Maybe<PaginatedAlertEntities>;
  paginated_source_entities?: Maybe<PaginatedAlertEntities>;
  rank: DetectionRank;
  tenant: Scalars['String']['output'];
  tenant_info?: Maybe<AlertAndDetectionTenantInfo>;
  total_alert_count: Scalars['Int']['output'];
  update_info?: Maybe<DetectionUpdateInfo>;
};


export type DetectionPaginatedDestinationEntitiesArgs = {
  paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
};


export type DetectionPaginatedSourceEntitiesArgs = {
  paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
};

export type DetectionAlertBucketSummary = {
  __typename?: 'DetectionAlertBucketSummary';
  alert_count?: Maybe<Scalars['Int']['output']>;
  bucket_end?: Maybe<Scalars['Float']['output']>;
  bucket_start?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type DetectionAlertGroupCountSummary = {
  __typename?: 'DetectionAlertGroupCountSummary';
  row_count?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Array<Maybe<DetectionAlertGroupSummary>>>;
};

export type DetectionAlertGroupSummary = {
  __typename?: 'DetectionAlertGroupSummary';
  alert_entity?: Maybe<AlertEntity>;
  alert_name?: Maybe<Scalars['String']['output']>;
  destination_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  destination_entities_total?: Maybe<Scalars['Int']['output']>;
  detections?: Maybe<Array<Maybe<DetectionAlertSummary>>>;
  entity_name?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_entities_total?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type DetectionAlertSummary = {
  __typename?: 'DetectionAlertSummary';
  alert_name?: Maybe<Scalars['String']['output']>;
  buckets?: Maybe<Array<Maybe<DetectionAlertBucketSummary>>>;
  detection_id?: Maybe<Scalars['String']['output']>;
  earliest_start_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  latest_start_timestamp?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
};

export enum DetectionAlertSummarySeverities {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type DetectionAssignmentInfo = {
  __typename?: 'DetectionAssignmentInfo';
  assigned_at?: Maybe<Scalars['Float']['output']>;
  assigned_to_user_alias?: Maybe<Scalars['String']['output']>;
  assigned_to_username?: Maybe<Scalars['String']['output']>;
};

export type DetectionAssignmentInfoInput = {
  assigned_to_username?: InputMaybe<Scalars['String']['input']>;
};

export type DetectionAutoCloseConfig = {
  __typename?: 'DetectionAutoCloseConfig';
  duration?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Int']['output']>;
};

export type DetectionCountsByMitreTactic = {
  __typename?: 'DetectionCountsByMitreTactic';
  detection_count: Scalars['Int']['output'];
  mitre_tactic: Scalars['String']['output'];
};

export type DetectionCountsBySeverityLevel = {
  __typename?: 'DetectionCountsBySeverityLevel';
  high?: Maybe<Scalars['Int']['output']>;
  low?: Maybe<Scalars['Int']['output']>;
  medium?: Maybe<Scalars['Int']['output']>;
};

export type DetectionCountsByStatus = {
  __typename?: 'DetectionCountsByStatus';
  closed?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Int']['output']>;
};

export type DetectionEscalationData = {
  __typename?: 'DetectionEscalationData';
  escalated_by_user_alias?: Maybe<Scalars['String']['output']>;
  escalated_timestamp?: Maybe<Scalars['Float']['output']>;
  escalation_service_name?: Maybe<EscalationServiceNameEnum>;
  escalation_status?: Maybe<Scalars['Boolean']['output']>;
};

export enum DetectionGroups {
  DetectionStatus = 'DETECTION_STATUS',
  MitreTactics = 'MITRE_TACTICS',
  SeverityLevels = 'SEVERITY_LEVELS'
}

export type DetectionId = {
  detection_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type DetectionKeys = {
  __typename?: 'DetectionKeys';
  tenant_detection?: Maybe<Scalars['String']['output']>;
  tenant_detection_entity?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
};

export type DetectionMethodBucket = {
  __typename?: 'DetectionMethodBucket';
  detection_method?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DetectionPeriodSummary = {
  __typename?: 'DetectionPeriodSummary';
  count?: Maybe<CurrentPreviousSummary>;
  end?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<ScoreDistribution>;
  start?: Maybe<Scalars['Float']['output']>;
  total_alert_categories?: Maybe<CurrentPreviousSummary>;
  total_entities?: Maybe<CurrentPreviousSummary>;
};

export type DetectionRank = {
  __typename?: 'DetectionRank';
  is_custom_severity?: Maybe<Scalars['Boolean']['output']>;
  severity: Scalars['Int']['output'];
};

export enum DetectionStatus {
  Closed = 'closed',
  Open = 'open'
}

export type DetectionSummary = {
  __typename?: 'DetectionSummary';
  alert_name?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  detection_count?: Maybe<Scalars['Int']['output']>;
  entity_category?: Maybe<Scalars['String']['output']>;
  entity_count?: Maybe<Scalars['Int']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  first_seen?: Maybe<Scalars['Float']['output']>;
  is_custom_severity?: Maybe<Scalars['Boolean']['output']>;
  last_seen?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_detection?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
  tenant_info?: Maybe<AlertAndDetectionTenantInfo>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export type DetectionSummaryInsights = {
  __typename?: 'DetectionSummaryInsights';
  ai_insights?: Maybe<AiInsights>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  detection_counts_by_mitre_tactics?: Maybe<Array<Maybe<DetectionCountsByMitreTactic>>>;
  detection_counts_by_severity_level?: Maybe<DetectionCountsBySeverityLevel>;
  detection_counts_by_status?: Maybe<DetectionCountsByStatus>;
  entity_category?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_locality?: Maybe<EntityLocality>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  max_severity?: Maybe<Scalars['Int']['output']>;
  most_severe_alert_category?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export type DetectionTacticSummary = {
  __typename?: 'DetectionTacticSummary';
  detection_count?: Maybe<Scalars['Int']['output']>;
  entity_count?: Maybe<Scalars['Int']['output']>;
  first_seen?: Maybe<Scalars['Float']['output']>;
  last_seen?: Maybe<Scalars['Float']['output']>;
  mitre_attack_tactic?: Maybe<Scalars['String']['output']>;
  mitre_attack_tactic_priority?: Maybe<Scalars['Int']['output']>;
  mitre_attack_techniques?: Maybe<Array<Maybe<DetectionTechniqueSummary>>>;
  tenant?: Maybe<Scalars['String']['output']>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export type DetectionTechniqueSummary = {
  __typename?: 'DetectionTechniqueSummary';
  detection_count?: Maybe<Scalars['Int']['output']>;
  entity_count?: Maybe<Scalars['Int']['output']>;
  first_seen?: Maybe<Scalars['Float']['output']>;
  last_seen?: Maybe<Scalars['Float']['output']>;
  mitre_attack_tactic?: Maybe<Scalars['String']['output']>;
  mitre_attack_tactic_priority?: Maybe<Scalars['Int']['output']>;
  mitre_attack_technique?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export type DetectionTimestamp = {
  __typename?: 'DetectionTimestamp';
  end?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
};

export type DetectionUpdateInfo = {
  __typename?: 'DetectionUpdateInfo';
  last_updated_by?: Maybe<Scalars['String']['output']>;
  last_updated_by_username?: Maybe<Scalars['String']['output']>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
};

export type DetectionUpdateInfoInput = {
  last_updated_timestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type DetectionsByDetectionGroupPerEntity = {
  __typename?: 'DetectionsByDetectionGroupPerEntity';
  detections?: Maybe<Array<Maybe<Detection>>>;
  detections_count?: Maybe<Scalars['Int']['output']>;
  group_key: Scalars['String']['output'];
};

export type DetectionsByDetectionGroupsPerEntity = {
  __typename?: 'DetectionsByDetectionGroupsPerEntity';
  data?: Maybe<Array<Maybe<DetectionsByDetectionGroupPerEntity>>>;
  end?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  group_by: DetectionGroups;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  start?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
};

export type DetectionsByEntityNameResult = {
  __typename?: 'DetectionsByEntityNameResult';
  detection_counts_by_mitre_tactics?: Maybe<Array<Maybe<DetectionCountsByMitreTactic>>>;
  detection_counts_by_severity_level?: Maybe<DetectionCountsBySeverityLevel>;
  detection_counts_by_status?: Maybe<DetectionCountsByStatus>;
  entity_name: Scalars['String']['output'];
  first_detection?: Maybe<Detection>;
  most_recent_detection?: Maybe<Detection>;
  most_severe_alert_categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  most_severe_detection?: Maybe<Detection>;
  number_of_most_severe_alert_categories?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export type DetectionsInfo = {
  __typename?: 'DetectionsInfo';
  description?: Maybe<Scalars['String']['output']>;
};

export type EdrConfiguration = {
  edr_action_enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  polling_seconds?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<EdrConfigurationType>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type EdrConfigurationInput = {
  crowdstrike?: InputMaybe<CrowdStrikeConfigurationInput>;
  microsoft_defender?: InputMaybe<MicrosoftDefenderConfigurationInput>;
  microsoft_entra_id?: InputMaybe<MicrosoftEntraIDConfigurationInput>;
  palo_alto_networks?: InputMaybe<PaloAltoNetworksConfigurationInput>;
  provider_name?: InputMaybe<EdrConfigurationType>;
};

export enum EdrConfigurationType {
  Crowdstrike = 'crowdstrike',
  CrowdstrikeIdentity = 'crowdstrike_identity',
  MicrosoftDefender = 'microsoft_defender',
  MicrosoftEntraId = 'microsoft_entra_id',
  PaloAltoNetworks = 'palo_alto_networks'
}

export type EulAacceptanceInfo = {
  __typename?: 'EULAacceptanceInfo';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Int']['output']>;
};

export type EditPrivilegeInput = {
  chatgpt?: InputMaybe<Scalars['Boolean']['input']>;
  chatgpt_agentic_triage?: InputMaybe<Scalars['Boolean']['input']>;
  chatgpt_private_data?: InputMaybe<Scalars['Boolean']['input']>;
  detection_auto_close_duration?: InputMaybe<Scalars['Int']['input']>;
};

export type EditUserInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type EdrDeviceInput = {
  detection_id?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
};

export type EdrEndpointDevice = {
  data_source?: Maybe<EdrConfigurationType>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_status?: Maybe<Scalars['String']['output']>;
  entity_status_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_type?: Maybe<EntityDataStoreEntityType>;
  expire_at?: Maybe<Scalars['Float']['output']>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  obsts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type EdrEndpointDeviceInput = {
  alert_entity_info: AlertEntityInfoInput;
  as_of?: InputMaybe<Scalars['Float']['input']>;
  tenant: Scalars['String']['input'];
};

export type EdrPayload = {
  __typename?: 'EdrPayload';
  ad_domain_name?: Maybe<Scalars['String']['output']>;
  ad_organizational_unit_name?: Maybe<Scalars['String']['output']>;
  cloud_account_id?: Maybe<Scalars['String']['output']>;
  cloud_instance_id?: Maybe<Scalars['String']['output']>;
  cloud_provider?: Maybe<Scalars['String']['output']>;
  data_source?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_status?: Maybe<Scalars['String']['output']>;
  entity_status_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_type?: Maybe<EntityDataStoreEntityType>;
  expire_at?: Maybe<Scalars['Float']['output']>;
  external_ips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  host_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  mac_addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nic_history?: Maybe<PaginatedNicHistory>;
  obsts?: Maybe<Scalars['Float']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  platform_type?: Maybe<Scalars['String']['output']>;
  sensor_version?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  user_history?: Maybe<PaginatedUserHistory>;
};

export type ElasticsearchBulk = {
  __typename?: 'ElasticsearchBulk';
  index: Scalars['String']['output'];
};

export type ElasticsearchBulkInput = {
  index: Scalars['String']['input'];
};

export type ElasticsearchExporter = Exporter & {
  __typename?: 'ElasticsearchExporter';
  auth?: Maybe<ElasticsearchExporterAuth>;
  bulk: ElasticsearchBulk;
  enabled: Scalars['Boolean']['output'];
  endpoint: Scalars['String']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  tls: ExporterTlsInfo;
};

export type ElasticsearchExporterAuth = {
  __typename?: 'ElasticsearchExporterAuth';
  password: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ElasticsearchExporterAuthInput = {
  password: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type ElasticsearchExporterInput = {
  auth: ElasticsearchExporterAuthInput;
  bulk: ElasticsearchBulkInput;
  endpoint: Scalars['String']['input'];
  tls: ExporterTlsInfoInput;
};

export enum EntityAction {
  DisableAccount = 'disable_account',
  EnableAccount = 'enable_account',
  IncreaseRiskScore = 'increase_risk_score',
  Isolate = 'isolate',
  LiftIsolation = 'lift_isolation',
  PasswordReset = 'password_reset',
  UniversalLogout = 'universal_logout'
}

export enum EntityCategory {
  Destination = 'destination',
  Source = 'source'
}

export enum EntityDataStoreAlertEntityType {
  Domain = 'DOMAIN',
  Host = 'HOST',
  Ip = 'IP',
  IpRange = 'IP_RANGE',
  Mac = 'MAC',
  User = 'USER'
}

export enum EntityDataStoreEntityType {
  Cert = 'cert',
  Domain = 'domain',
  EndpointDevice = 'endpoint_device',
  Host = 'host',
  Ip = 'ip',
  Location = 'location',
  Network = 'network',
  NetworkDevice = 'network_device',
  Service = 'service',
  Software = 'software',
  User = 'user'
}

export type EntityDetectionTimeline = {
  __typename?: 'EntityDetectionTimeline';
  data?: Maybe<Array<Maybe<EntityDetectionTimelineItem>>>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  is_custom_severity?: Maybe<Scalars['Boolean']['output']>;
  is_truncated?: Maybe<Scalars['Boolean']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
  tenant_info?: Maybe<AlertAndDetectionTenantInfo>;
  total_detections?: Maybe<Scalars['Int']['output']>;
  total_grouped_entities?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type EntityDetectionTimelineItem = {
  __typename?: 'EntityDetectionTimelineItem';
  alert_name?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  first_seen?: Maybe<Scalars['Float']['output']>;
  is_custom_severity?: Maybe<Scalars['Boolean']['output']>;
  last_seen?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_detection?: Maybe<Scalars['String']['output']>;
  tenant_entity?: Maybe<Scalars['String']['output']>;
  tenant_info?: Maybe<AlertAndDetectionTenantInfo>;
  total_detections?: Maybe<Scalars['Int']['output']>;
};

export enum EntityEdrStatus {
  Isolated = 'isolated',
  IsolationPending = 'isolation_pending',
  IsolationRequested = 'isolation_requested',
  LiftIsolationPending = 'lift_isolation_pending',
  LiftIsolationRequested = 'lift_isolation_requested',
  Normal = 'normal'
}

export type EntityEdrStatusWithTimestamp = {
  __typename?: 'EntityEdrStatusWithTimestamp';
  entity_edr_status?: Maybe<EntityEdrStatus>;
  tenant?: Maybe<Scalars['String']['output']>;
  updated_timestamp?: Maybe<Scalars['Float']['output']>;
};

export type EntityEdrStatusWithTimestampExt = {
  __typename?: 'EntityEdrStatusWithTimestampExt';
  device_id?: Maybe<Scalars['String']['output']>;
  edr_provider?: Maybe<Scalars['String']['output']>;
  entity_edr_status?: Maybe<EntityEdrStatus>;
  hostname?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  updated_timestamp?: Maybe<Scalars['Float']['output']>;
};

export type EntityFilter = {
  __typename?: 'EntityFilter';
  dest?: Maybe<EntityObj>;
  source?: Maybe<EntityObj>;
  source_dest?: Maybe<EntityObj>;
};

export type EntityFilterInput = {
  dest?: InputMaybe<EntityObjInput>;
  source?: InputMaybe<EntityObjInput>;
  source_dest?: InputMaybe<EntityObjInput>;
};

export type EntityIdInput = {
  entity_id?: InputMaybe<Scalars['String']['input']>;
  entity_type?: InputMaybe<EntityDataStoreEntityType>;
};

export type EntityInfo = {
  __typename?: 'EntityInfo';
  summary?: Maybe<Scalars['String']['output']>;
};

export enum EntityLocality {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Na = 'NA'
}

export type EntityObj = {
  __typename?: 'EntityObj';
  dest_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dest_entities_total?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_entities_total?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type EntityObjInput = {
  dest_entities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dest_entities_total?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source_entities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_entities_total?: InputMaybe<Scalars['Int']['input']>;
  total_items?: InputMaybe<Scalars['Int']['input']>;
};

export type EntitySuggestions = {
  __typename?: 'EntitySuggestions';
  destination_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_entities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EntitySuppressionConfiguration = {
  __typename?: 'EntitySuppressionConfiguration';
  fields_to_suppress?: Maybe<Array<Maybe<AlertField>>>;
  file_content?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_updated_at?: Maybe<Scalars['Float']['output']>;
  file_updated_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason_for_suppression?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export enum EntityType {
  Domain = 'domain',
  Email = 'email',
  Hostname = 'hostname',
  Ip = 'ip',
  Request = 'request',
  Sipdip = 'sipdip',
  Sipdomain = 'sipdomain',
  User = 'user'
}

export type EntraDeviceDetail = {
  __typename?: 'EntraDeviceDetail';
  device_id?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  is_compliant?: Maybe<Scalars['Boolean']['output']>;
  is_managed?: Maybe<Scalars['Boolean']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
};

export type EntraDocMetadata = {
  __typename?: 'EntraDocMetadata';
  last_refreshed_at?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type EntraIdentityUserDoc = {
  __typename?: 'EntraIdentityUserDoc';
  microsoft_entra_id?: Maybe<EntraIdentityUserPayload>;
  tenant?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type EntraIdentityUserInput = {
  tenant: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type EntraIdentityUserPayload = {
  __typename?: 'EntraIdentityUserPayload';
  ADGroup?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  account_enabled?: Maybe<Scalars['Boolean']['output']>;
  business_phones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  department?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  mobile_phone?: Maybe<Scalars['String']['output']>;
  office_location?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  risk_level?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  user_principal_name?: Maybe<Scalars['String']['output']>;
};

export type EntraLocation = {
  __typename?: 'EntraLocation';
  city?: Maybe<Scalars['String']['output']>;
  country_or_region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type EntraSigninEvent = {
  __typename?: 'EntraSigninEvent';
  application_display_name?: Maybe<Scalars['String']['output']>;
  client_app_used?: Maybe<Scalars['String']['output']>;
  conditional_access_status?: Maybe<Scalars['String']['output']>;
  created_date_time?: Maybe<Scalars['String']['output']>;
  created_date_time_epoch?: Maybe<Scalars['Float']['output']>;
  device_detail?: Maybe<EntraDeviceDetail>;
  event_id?: Maybe<Scalars['String']['output']>;
  external_ip?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EntraLocation>;
  risk_level_aggregated?: Maybe<Scalars['String']['output']>;
  risk_level_during_signin?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EntraSigninStatus>;
};

export type EntraSigninHistoryDoc = {
  __typename?: 'EntraSigninHistoryDoc';
  microsoft_entra_id?: Maybe<EntraSigninHistoryPayload>;
  tenant?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type EntraSigninHistoryPayload = {
  __typename?: 'EntraSigninHistoryPayload';
  metadata?: Maybe<EntraDocMetadata>;
  raw?: Maybe<Scalars['String']['output']>;
  sign_in?: Maybe<EntraSigninEvent>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_principal_name?: Maybe<Scalars['String']['output']>;
};

export type EntraSigninHistoryResult = {
  __typename?: 'EntraSigninHistoryResult';
  items?: Maybe<Array<Maybe<EntraSigninWithUser>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type EntraSigninHistorySearchInput = {
  as_of?: InputMaybe<Scalars['Float']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};

export type EntraSigninStatus = {
  __typename?: 'EntraSigninStatus';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
};

export type EntraSigninWithUser = {
  __typename?: 'EntraSigninWithUser';
  signin?: Maybe<EntraSigninHistoryDoc>;
  user?: Maybe<EntraIdentityUserDoc>;
};

export type EscalateDetectionInput = {
  detection_id: Scalars['String']['input'];
  escalation_configuration_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type EscalatedDetection = {
  __typename?: 'EscalatedDetection';
  detection_id: Scalars['String']['output'];
  escalated: Scalars['Boolean']['output'];
  escalation_configuration_id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type EscalationConfiguration = {
  enabled: Scalars['Boolean']['output'];
  escalation_configuration_id: Scalars['String']['output'];
  service_name: ServiceNameEnum;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type EscalationConfigurationFilter = {
  __typename?: 'EscalationConfigurationFilter';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  escalation_configuration_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  service_names?: Maybe<Array<Maybe<ServiceNameEnum>>>;
};

export type EscalationConfigurationFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  escalation_configuration_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_names?: InputMaybe<Array<InputMaybe<ServiceNameEnum>>>;
};

export type EscalationConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  escalation_configuration_id?: InputMaybe<Scalars['String']['input']>;
  service_name: ServiceNameEnum;
  servicenow?: InputMaybe<ServiceNowEscalationConfigurationInput>;
};

export enum EscalationServiceNameEnum {
  Servicenow = 'servicenow'
}

export enum EventCategory {
  AdminUserActions = 'ADMIN_USER_ACTIONS',
  Integration = 'INTEGRATION',
  MonitorUserActions = 'MONITOR_USER_ACTIONS',
  System = 'SYSTEM',
  User = 'USER'
}

export enum EventSubCategory {
  AliasUpdate = 'ALIAS_UPDATE',
  CookieUpdate = 'COOKIE_UPDATE',
  EnableDisableConfiguration = 'ENABLE_DISABLE_CONFIGURATION',
  GetPrivacyAuditReport = 'GET_PRIVACY_AUDIT_REPORT',
  IncorrectPassword = 'INCORRECT_PASSWORD',
  LicenseViewed = 'LICENSE_VIEWED',
  LogOut = 'LOG_OUT',
  MfaRegistered = 'MFA_REGISTERED',
  MfaUpdate = 'MFA_UPDATE',
  NewPasswordUpdated = 'NEW_PASSWORD_UPDATED',
  PasswordChange = 'PASSWORD_CHANGE',
  PrivacyPolicyAcknowledged = 'PRIVACY_POLICY_ACKNOWLEDGED',
  SignedInWithTemporaryCredentials = 'SIGNED_IN_WITH_TEMPORARY_CREDENTIALS'
}

export type Evidence = {
  __typename?: 'Evidence';
  agent?: Maybe<Scalars['String']['output']>;
  detection_id?: Maybe<Scalars['String']['output']>;
  entity_triage_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EvidenceSource>;
  tool_name?: Maybe<Scalars['String']['output']>;
};

export type EvidenceInput = {
  agent: Scalars['String']['input'];
  detection_id?: InputMaybe<Scalars['String']['input']>;
  entity_triage_id: Scalars['String']['input'];
  source: EvidenceSource;
  tool_name: Scalars['String']['input'];
};

export enum EvidenceSource {
  NoneRequired = 'none_required',
  Tool = 'tool'
}

export type ExcludedEntity = {
  __typename?: 'ExcludedEntity';
  _score?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_alias?: Maybe<Scalars['String']['output']>;
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_ip?: Maybe<Scalars['String']['output']>;
  entity_ip_range?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<AlertEntityType>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type ExcludedEntityInput = {
  alert_name: Scalars['String']['input'];
  alert_type: Scalars['String']['input'];
  content_id: Scalars['String']['input'];
  created_timestamp?: InputMaybe<Scalars['Float']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  entity_ip?: InputMaybe<Scalars['String']['input']>;
  entity_ip_range?: InputMaybe<Scalars['String']['input']>;
  entity_name: Scalars['String']['input'];
  entity_type: AlertEntityType;
  tenant: Scalars['String']['input'];
};

export type Exporter = {
  enabled: Scalars['Boolean']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
};

export type ExporterIdInput = {
  exporter_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type ExporterInput = {
  elasticsearch?: InputMaybe<ElasticsearchExporterInput>;
  enabled: Scalars['Boolean']['input'];
  exporter: ExporterType;
  exporter_id?: InputMaybe<Scalars['String']['input']>;
  http?: InputMaybe<HttpExporterInput>;
  logscale?: InputMaybe<LogscaleExporterInput>;
  name: Scalars['String']['input'];
  splunk_hec_logs?: InputMaybe<SplunkHecLogsExporterInput>;
  tenant: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type ExporterTlsInfo = {
  __typename?: 'ExporterTLSInfo';
  verify_certificate: Scalars['Boolean']['output'];
};

export type ExporterTlsInfoInput = {
  verify_certificate: Scalars['Boolean']['input'];
};

export enum ExporterType {
  Elasticsearch = 'elasticsearch',
  Http = 'http',
  Logscale = 'logscale',
  SplunkHecLogs = 'splunk_hec_logs'
}

export type FeatureHistogramBin = {
  __typename?: 'FeatureHistogramBin';
  count?: Maybe<Scalars['Int']['output']>;
  cut?: Maybe<Scalars['Float']['output']>;
};

export type FeatureHistogramData = {
  __typename?: 'FeatureHistogramData';
  bins?: Maybe<Array<Maybe<FeatureHistogramBin>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureImportance = {
  __typename?: 'FeatureImportance';
  importance?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureMetaDataGetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  feature_names?: InputMaybe<Array<Scalars['String']['input']>>;
  pipeline?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureMetadata = {
  __typename?: 'FeatureMetadata';
  category?: Maybe<Scalars['String']['output']>;
  data_type?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
};

export type FeatureMetadataInput = {
  category: Scalars['String']['input'];
  data_type: Scalars['String']['input'];
  definition?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  is_feature?: InputMaybe<Scalars['Boolean']['input']>;
  log_type?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pipeline: Scalars['String']['input'];
};

export type FeatureMinMaxData = {
  __typename?: 'FeatureMinMaxData';
  max?: Maybe<Scalars['Float']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pct_5?: Maybe<Scalars['Float']['output']>;
  pct_10?: Maybe<Scalars['Float']['output']>;
  pct_25?: Maybe<Scalars['Float']['output']>;
  pct_50?: Maybe<Scalars['Float']['output']>;
  pct_75?: Maybe<Scalars['Float']['output']>;
  pct_90?: Maybe<Scalars['Float']['output']>;
  pct_95?: Maybe<Scalars['Float']['output']>;
  std?: Maybe<Scalars['Float']['output']>;
};

export enum FederationTypes {
  Member = 'MEMBER',
  None = 'NONE',
  Org = 'ORG'
}

export type FilterResponse = {
  __typename?: 'FilterResponse';
  alert_name_filter?: Maybe<Array<Maybe<NameIdMapping>>>;
  entity_filter?: Maybe<EntityFilter>;
  ip_filter?: Maybe<IpResponse>;
  offset?: Maybe<Scalars['Int']['output']>;
  severity_filter?: Maybe<Array<Maybe<DetectionAlertSummarySeverities>>>;
  size?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type GenericAlert = Alert & {
  __typename?: 'GenericAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Scalars['JSONSTRING']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  score?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenant: Scalars['String']['output'];
};

export type GenericExporter = Exporter & {
  __typename?: 'GenericExporter';
  enabled: Scalars['Boolean']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  fields?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
};

export type GetAlertInput = {
  alert_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GetAlertMetadataInput = {
  content_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type GetUserLogsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserLogFilterInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Group = {
  __typename?: 'Group';
  group_name?: Maybe<Scalars['String']['output']>;
};

export enum HttpAuthStrategy {
  Basic = 'basic',
  Bearer = 'bearer',
  None = 'none'
}

export type HttpExporter = Exporter & {
  __typename?: 'HttpExporter';
  auth?: Maybe<HttpExporterAuth>;
  enabled: Scalars['Boolean']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  headers?: Maybe<Array<HttpExporterHeader>>;
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  tls: ExporterTlsInfo;
  uri: Scalars['String']['output'];
};

export type HttpExporterAuth = {
  __typename?: 'HttpExporterAuth';
  basic?: Maybe<HttpExporterAuthBasic>;
  bearer?: Maybe<HttpExporterAuthBearer>;
  strategy: HttpAuthStrategy;
};

export type HttpExporterAuthBasic = {
  __typename?: 'HttpExporterAuthBasic';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type HttpExporterAuthBasicInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type HttpExporterAuthBearer = {
  __typename?: 'HttpExporterAuthBearer';
  token: Scalars['String']['output'];
};

export type HttpExporterAuthBearerInput = {
  token: Scalars['String']['input'];
};

export type HttpExporterAuthInput = {
  basic?: InputMaybe<HttpExporterAuthBasicInput>;
  bearer?: InputMaybe<HttpExporterAuthBearerInput>;
  strategy: HttpAuthStrategy;
};

export type HttpExporterHeader = {
  __typename?: 'HttpExporterHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HttpExporterHeaderInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HttpExporterInput = {
  auth?: InputMaybe<HttpExporterAuthInput>;
  headers?: InputMaybe<Array<HttpExporterHeaderInput>>;
  tls: ExporterTlsInfoInput;
  uri: Scalars['String']['input'];
};

export type HumioDomainOutput = {
  __typename?: 'HumioDomainOutput';
  searchDomain?: Maybe<HumioTenant>;
};

export type HumioTenant = {
  __typename?: 'HumioTenant';
  dashboards?: Maybe<Array<Maybe<Dashboard>>>;
};

export type IpFilter = {
  dest?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_dest?: InputMaybe<IpInput>;
};

export type IpInput = {
  dest?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IpObj = {
  __typename?: 'IPObj';
  dest?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IpResponse = {
  __typename?: 'IPResponse';
  dest?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_dest?: Maybe<IpObj>;
};

export type IdentityIncident = {
  __typename?: 'IdentityIncident';
  id?: Maybe<Scalars['String']['output']>;
  incident?: Maybe<CrowdStrikeIncidentDetail>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type IdpDescription = {
  __typename?: 'IdpDescription';
  attribute_mapping?: Maybe<Scalars['JSONSTRING']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  idp_identifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  idp_user_role_mapping?: Maybe<Scalars['JSONSTRING']['output']>;
  is_sso_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['Int']['output']>;
  provider_details?: Maybe<Scalars['JSONSTRING']['output']>;
  provider_type?: Maybe<Scalars['String']['output']>;
};

export type IdpDomains = {
  __typename?: 'IdpDomains';
  domains: Array<Scalars['String']['output']>;
  pagination?: Maybe<PaginationType>;
};

export type IntelAlert = Alert & {
  __typename?: 'IntelAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  cif_confidence?: Maybe<Scalars['Float']['output']>;
  cif_description?: Maybe<Scalars['String']['output']>;
  cif_firstseen?: Maybe<Scalars['String']['output']>;
  cif_lastseen?: Maybe<Scalars['String']['output']>;
  cif_source?: Maybe<Scalars['String']['output']>;
  cif_tags?: Maybe<Scalars['String']['output']>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  destination_ip?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  file_desc?: Maybe<Scalars['String']['output']>;
  file_mime_type?: Maybe<Scalars['String']['output']>;
  fuid?: Maybe<Scalars['String']['output']>;
  matched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orig_h?: Maybe<Scalars['String']['output']>;
  orig_p?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  resp_h?: Maybe<Scalars['String']['output']>;
  resp_p?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  seen_indicator?: Maybe<Scalars['String']['output']>;
  seen_indicator_type?: Maybe<Scalars['String']['output']>;
  seen_node?: Maybe<Scalars['String']['output']>;
  seen_where?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_ip?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  system_name?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  uid?: Maybe<Scalars['String']['output']>;
};

export type KeyFinding = {
  __typename?: 'KeyFinding';
  description?: Maybe<Scalars['String']['output']>;
  evidences?: Maybe<Array<Maybe<Evidence>>>;
  justification?: Maybe<Scalars['String']['output']>;
  logs_query?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type KeyFindings = {
  __typename?: 'KeyFindings';
  key_findings?: Maybe<Array<Maybe<KeyFinding>>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type KeyFindingsInfo = {
  __typename?: 'KeyFindingsInfo';
  key_findings?: Maybe<Array<Maybe<KeyFinding>>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type KinesisConnectionDetails = {
  __typename?: 'KinesisConnectionDetails';
  access_key?: Maybe<Scalars['String']['output']>;
  aws_region?: Maybe<Scalars['String']['output']>;
  secret_key?: Maybe<Scalars['String']['output']>;
  stream_name?: Maybe<Scalars['String']['output']>;
};

export type LicenseInfo = {
  __typename?: 'LicenseInfo';
  display_name?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Int']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  federation_type?: Maybe<FederationTypes>;
  gbps?: Maybe<Scalars['String']['output']>;
  input_region?: Maybe<Scalars['String']['output']>;
  license_type?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<TenantMember>>>;
  org?: Maybe<Scalars['String']['output']>;
  primary_contact?: Maybe<PrimaryContact>;
  retention_days?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  system_info?: Maybe<SystemInfo>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_location?: Maybe<Scalars['String']['output']>;
  tenant_type?: Maybe<Scalars['String']['output']>;
};

export type LogOperationInput = {
  data?: InputMaybe<Scalars['JSONSTRING']['input']>;
  event_category?: InputMaybe<EventCategory>;
  event_sub_category: EventSubCategory;
};

export type LogscaleExporter = Exporter & {
  __typename?: 'LogscaleExporter';
  enabled: Scalars['Boolean']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  index?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  tls: ExporterTlsInfo;
  token?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type LogscaleExporterInput = {
  index: Scalars['String']['input'];
  tls: ExporterTlsInfoInput;
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MlFeatures = {
  __typename?: 'MLFeatures';
  actual?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Scalars['Float']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  feature_name?: Maybe<Scalars['String']['output']>;
};

export type MlModels = {
  __typename?: 'MLModels';
  features?: Maybe<Array<Maybe<MlFeatures>>>;
  model_alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  model_name?: Maybe<Scalars['String']['output']>;
  model_score?: Maybe<Scalars['Float']['output']>;
  predicted_tag_id?: Maybe<Scalars['String']['output']>;
};

export type MlWhiteListEntry = {
  __typename?: 'MLWhiteListEntry';
  entity_name?: Maybe<Scalars['String']['output']>;
  whitelisted?: Maybe<Scalars['Boolean']['output']>;
  whitelisted_for?: Maybe<Scalars['String']['output']>;
};

export enum ManagedBy {
  AutoDetect = 'AUTO_DETECT',
  Corelight = 'CORELIGHT',
  Tenant = 'TENANT'
}

export type MetadataEventStrategy = {
  __typename?: 'MetadataEventStrategy';
  alert_sid?: Maybe<Scalars['String']['output']>;
  attack_probability_threshold?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  predicted_tag_id?: Maybe<Scalars['String']['output']>;
};

export type MetadataLogSource = {
  __typename?: 'MetadataLogSource';
  category?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

export type MetadataRelated = {
  __typename?: 'MetadataRelated';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftDefenderConfiguration = EdrConfiguration & {
  __typename?: 'MicrosoftDefenderConfiguration';
  app_id?: Maybe<Scalars['String']['output']>;
  app_secret?: Maybe<Scalars['String']['output']>;
  defender_tenant_id?: Maybe<Scalars['String']['output']>;
  edr_action_enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  polling_seconds?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<EdrConfigurationType>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftDefenderConfigurationInput = {
  app_id: Scalars['String']['input'];
  app_secret: Scalars['String']['input'];
  defender_tenant_id: Scalars['String']['input'];
  edr_action_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  polling_seconds: Scalars['Int']['input'];
};

export type MicrosoftDefenderEndpointDevice = EdrEndpointDevice & {
  __typename?: 'MicrosoftDefenderEndpointDevice';
  data_source?: Maybe<EdrConfigurationType>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_status?: Maybe<Scalars['String']['output']>;
  entity_status_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  entity_type?: Maybe<EntityDataStoreEntityType>;
  expire_at?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
  machine?: Maybe<MicrosoftDefenderMachine>;
  machine_actions?: Maybe<Array<Maybe<MicrosoftDefenderMachineActions>>>;
  obsts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftDefenderIpAddresses = {
  __typename?: 'MicrosoftDefenderIpAddresses';
  ipAddress?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  operationalStatus?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftDefenderMachine = {
  __typename?: 'MicrosoftDefenderMachine';
  aadDeviceId?: Maybe<Scalars['String']['output']>;
  agentVersion?: Maybe<Scalars['String']['output']>;
  computerDnsName?: Maybe<Scalars['String']['output']>;
  defenderAvStatus?: Maybe<Scalars['String']['output']>;
  deviceValue?: Maybe<Scalars['String']['output']>;
  exclusionReason?: Maybe<Scalars['String']['output']>;
  exposureLevel?: Maybe<Scalars['String']['output']>;
  firstSeen?: Maybe<Scalars['Float']['output']>;
  healthStatus?: Maybe<Scalars['String']['output']>;
  ipAddresses?: Maybe<Array<Maybe<MicrosoftDefenderIpAddresses>>>;
  isAadJoined?: Maybe<Scalars['Boolean']['output']>;
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  isPotentialDuplication?: Maybe<Scalars['Boolean']['output']>;
  lastExternalIpAddress?: Maybe<Scalars['String']['output']>;
  lastIpAddress?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['Float']['output']>;
  machineTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  managedBy?: Maybe<Scalars['String']['output']>;
  managedByStatus?: Maybe<Scalars['String']['output']>;
  mergedIntoMachineId?: Maybe<Scalars['String']['output']>;
  onboardingStatus?: Maybe<Scalars['String']['output']>;
  osArchitecture?: Maybe<Scalars['String']['output']>;
  osBuild?: Maybe<Scalars['Int']['output']>;
  osPlatform?: Maybe<Scalars['String']['output']>;
  osProcessor?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  rbacGroupId?: Maybe<Scalars['Int']['output']>;
  rbacGroupName?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  vmMetadata?: Maybe<MicrosoftDefenderVmMetadata>;
};

export type MicrosoftDefenderMachineActions = {
  __typename?: 'MicrosoftDefenderMachineActions';
  creationDateTimeUtc?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdateDateTimeUtc?: Maybe<Scalars['Float']['output']>;
  requestor?: Maybe<Scalars['String']['output']>;
  requestorComment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftDefenderVmMetadata = {
  __typename?: 'MicrosoftDefenderVmMetadata';
  cloudProvider?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  vmId?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftEntraIDConfiguration = EdrConfiguration & {
  __typename?: 'MicrosoftEntraIDConfiguration';
  edr_action_enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entra_client_id?: Maybe<Scalars['String']['output']>;
  entra_client_secret?: Maybe<Scalars['String']['output']>;
  entra_tenant_id?: Maybe<Scalars['String']['output']>;
  identity_enrichment_enabled?: Maybe<Scalars['Boolean']['output']>;
  polling_seconds?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<EdrConfigurationType>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftEntraIDConfigurationInput = {
  edr_action_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entra_client_id: Scalars['String']['input'];
  entra_client_secret: Scalars['String']['input'];
  entra_tenant_id: Scalars['String']['input'];
  identity_enrichment_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  polling_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type MitreMappings = {
  __typename?: 'MitreMappings';
  tactics?: Maybe<Array<Maybe<MitreTactics>>>;
};

export type MitreSubtechniques = {
  __typename?: 'MitreSubtechniques';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MitreTactics = {
  __typename?: 'MitreTactics';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  techniques?: Maybe<Array<Maybe<MitreTechniques>>>;
};

export type MitreTechniques = {
  __typename?: 'MitreTechniques';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtechniques?: Maybe<Array<Maybe<MitreSubtechniques>>>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MlAlert = Alert & {
  __typename?: 'MlAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  average_technique_score_map?: Maybe<Scalars['JSONSTRING']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Array<Maybe<MlModels>>>;
  pipeline?: Maybe<Scalars['String']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  score?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  user_tag?: Maybe<Scalars['JSONSTRING']['output']>;
  whitelisted_info?: Maybe<Array<Maybe<MlWhiteListEntry>>>;
};

export enum Mode {
  Batch = 'batch',
  Realtime = 'realtime'
}

export type ModelDeployment = {
  __typename?: 'ModelDeployment';
  deployment_ts?: Maybe<Scalars['Int']['output']>;
  is_deployed?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  model_alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  model_name?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  silent_mode?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ModelDeploymentAddInput = {
  is_deployed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Mode>;
  model_alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model_name: Scalars['String']['input'];
  model_type: ModelType;
  pipeline: Pipeline;
  silent_mode?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelDeploymentUpdateInput = {
  is_deployed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Mode>;
  model_alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model_name: Scalars['String']['input'];
  model_type?: InputMaybe<ModelType>;
  pipeline?: InputMaybe<Pipeline>;
  silent_mode?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelDeploymentsGetInput = {
  is_deployed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Mode>;
  model_type?: InputMaybe<ModelType>;
  pipeline?: InputMaybe<Pipeline>;
};

export type ModelFeatureSummary = {
  __typename?: 'ModelFeatureSummary';
  feature_count?: Maybe<Scalars['Int']['output']>;
  feature_histograms?: Maybe<Array<Maybe<FeatureHistogramData>>>;
  feature_minmax?: Maybe<Array<Maybe<FeatureMinMaxData>>>;
  model_id?: Maybe<Scalars['String']['output']>;
};

export type ModelLabelCounts = {
  __typename?: 'ModelLabelCounts';
  normal?: Maybe<Scalars['Int']['output']>;
  unknown?: Maybe<Scalars['Int']['output']>;
};

export type ModelLabels = {
  __typename?: 'ModelLabels';
  tag?: Maybe<Array<Maybe<ModelLabelsTagCount>>>;
  used_global_labels?: Maybe<ModelLabelCounts>;
  used_local_labels?: Maybe<ModelLabelCounts>;
};

export type ModelLabelsTagCount = {
  __typename?: 'ModelLabelsTagCount';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ModelParameters = {
  __typename?: 'ModelParameters';
  mode?: Maybe<Scalars['String']['output']>;
};

export type ModelPerformanceCurves = {
  __typename?: 'ModelPerformanceCurves';
  pr_curve_thresholds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pr_curve_x?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pr_curve_y?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  roc_curve_thresholds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  roc_curve_x?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  roc_curve_y?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type ModelPerformanceStats = {
  __typename?: 'ModelPerformanceStats';
  auc?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  estimated_daily_alerts?: Maybe<Scalars['Float']['output']>;
  pdr?: Maybe<Scalars['Float']['output']>;
  pr_auc?: Maybe<Scalars['Float']['output']>;
};

export type ModelSummary = {
  __typename?: 'ModelSummary';
  algorithm_params?: Maybe<AlgorithmParameters>;
  del_features?: Maybe<Scalars['String']['output']>;
  feature_details?: Maybe<ModelFeatureSummary>;
  feature_importance?: Maybe<Array<Maybe<FeatureImportance>>>;
  labels?: Maybe<ModelLabels>;
  model_description?: Maybe<Scalars['String']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_parameters?: Maybe<ModelParameters>;
  model_trained_by?: Maybe<Scalars['String']['output']>;
  model_trained_on?: Maybe<Scalars['String']['output']>;
  performance_curves?: Maybe<ModelPerformanceCurves>;
  performance_stats?: Maybe<ModelPerformanceStats>;
  preprocessing_filters?: Maybe<PreprocessingFilters>;
  satisfactory_auc?: Maybe<Scalars['Float']['output']>;
  satisfactory_tpr?: Maybe<Scalars['Float']['output']>;
  successful_training?: Maybe<Scalars['Boolean']['output']>;
  tag_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  training_set_dates?: Maybe<TrainingSetDates>;
  training_set_size?: Maybe<Scalars['Int']['output']>;
  used_features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ModelType {
  Classifier = 'Classifier',
  Ranking = 'Ranking'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptEulaTC?: Maybe<UserSuccessOutput>;
  acceptHumioTC?: Maybe<SuccessOutput>;
  activateUserAccount?: Maybe<UserSuccessOutput>;
  addBulkFeatureMetadata?: Maybe<Scalars['JSONSTRING']['output']>;
  addBulkTags?: Maybe<Scalars['JSONSTRING']['output']>;
  addBulkWhitelistedEntity?: Maybe<Scalars['JSONSTRING']['output']>;
  addExcludedEntitiesToAlertMetadata?: Maybe<PaginatedExcludedEntities>;
  addIdpDomain?: Maybe<UserSuccessOutput>;
  addModelDeployment?: Maybe<ModelDeployment>;
  assignDetections?: Maybe<PaginatedDetections>;
  configureAndEnableIdentityProvider?: Maybe<UserSuccessOutput>;
  configureIdentityProvider?: Maybe<UserSuccessOutput>;
  createAPIKeyDefinition?: Maybe<ApiKeyDefinition>;
  createBulkCommentsForDetections: BulkCommentsOperationResult;
  createComment?: Maybe<Comment>;
  createEntitySuppressionConfiguration?: Maybe<EntitySuppressionConfiguration>;
  createQueryJob?: Maybe<CreateQueryJobResult>;
  createQueryJobAndPoll?: Maybe<PaginatedQueryJobResult>;
  createUser?: Maybe<UserSuccessOutput>;
  deleteAPIKeyDefinition?: Maybe<ApiKeyDefinition>;
  deleteComment?: Maybe<Comment>;
  deleteEDRConfiguration?: Maybe<EdrConfiguration>;
  deleteEntitySuppressionConfiguration?: Maybe<EntitySuppressionConfiguration>;
  deleteEscalationConfigurations?: Maybe<Array<Maybe<EscalationConfiguration>>>;
  deleteExporter?: Maybe<Scalars['Boolean']['output']>;
  deleteFeatureMetadata?: Maybe<Scalars['JSONSTRING']['output']>;
  deleteIdentityProvider?: Maybe<UserSuccessOutput>;
  deleteModelDeployment?: Maybe<SuccessOutput>;
  deleteTag?: Maybe<SuccessOutput>;
  deleteUsers?: Maybe<UserSuccessOutput>;
  deleteWhitelistedEntity?: Maybe<Scalars['JSONSTRING']['output']>;
  editComment?: Maybe<Comment>;
  editUser?: Maybe<UserSuccessOutput>;
  enableDisableUserPoolAppClientIdp?: Maybe<UserSuccessOutput>;
  enableDisableUsers?: Maybe<UserSuccessOutput>;
  escalateDetections?: Maybe<Array<Maybe<EscalatedDetection>>>;
  logOperation?: Maybe<UserSuccessOutput>;
  performEdrAction?: Maybe<EntityEdrStatusWithTimestampExt>;
  populateModel?: Maybe<ModelSummary>;
  pullEntityEdrStatus?: Maybe<EntityEdrStatusWithTimestamp>;
  removeExcludedEntitiesFromAlertMetadata?: Maybe<PaginatedExcludedEntities>;
  removeIdpDomain?: Maybe<UserSuccessOutput>;
  rotateAPIKeyDefinition?: Maybe<ApiKeyDefinition>;
  saveEscalationConfigurations?: Maybe<Array<Maybe<EscalationConfiguration>>>;
  saveExporter?: Maybe<Exporter>;
  sendEmail?: Maybe<SuccessOutput>;
  setAlertActiveStatus?: Maybe<PaginatedAlertMetadata>;
  setAlertAndDetectionTenantConfigs?: Maybe<ConfigResponse>;
  setAlertStatusBySearchTerm: Array<Maybe<SetAlertStatusBySearchTermResult>>;
  setSeverityOnAlerts?: Maybe<PaginatedAlertMetadata>;
  setStatusOnDetections?: Maybe<PaginatedDetections>;
  storeEDRConfiguration?: Maybe<EdrConfiguration>;
  updateEntitySuppressionConfiguration?: Maybe<EntitySuppressionConfiguration>;
  updateFeatureMetadata?: Maybe<SuccessOutput>;
  updateIdentityProvider?: Maybe<UserSuccessOutput>;
  updateModelDeployment?: Maybe<ModelDeployment>;
  updatePrivileges?: Maybe<SuccessOutput>;
  updateProfile?: Maybe<UserSuccessOutput>;
  updateTag?: Maybe<SuccessOutput>;
  updateTenantDisplayName?: Maybe<TenantDisplayNameInfo>;
  updateWhitelistedEntity?: Maybe<WhitelistedEntity>;
  userUpdateCookieStatus?: Maybe<UserSuccessOutput>;
};


export type MutationAcceptHumioTcArgs = {
  humioSessionToken: Scalars['String']['input'];
};


export type MutationAddBulkFeatureMetadataArgs = {
  input: Array<FeatureMetadataInput>;
};


export type MutationAddBulkTagsArgs = {
  input: Array<TagInput>;
};


export type MutationAddBulkWhitelistedEntityArgs = {
  input: Array<WhitelistedEntityInput>;
};


export type MutationAddExcludedEntitiesToAlertMetadataArgs = {
  items: Array<InputMaybe<ExcludedEntityInput>>;
};


export type MutationAddIdpDomainArgs = {
  idp_domain: Scalars['String']['input'];
};


export type MutationAddModelDeploymentArgs = {
  input: ModelDeploymentAddInput;
};


export type MutationAssignDetectionsArgs = {
  items: Array<AssignDetectionsInput>;
};


export type MutationConfigureAndEnableIdentityProviderArgs = {
  attribute_mapping: Scalars['String']['input'];
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
  provider_details: Scalars['String']['input'];
  provider_type: Scalars['String']['input'];
};


export type MutationConfigureIdentityProviderArgs = {
  attribute_mapping: Scalars['String']['input'];
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
  provider_details: Scalars['String']['input'];
  provider_type: Scalars['String']['input'];
};


export type MutationCreateApiKeyDefinitionArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  end_ts?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  start_ts?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateBulkCommentsForDetectionsArgs = {
  comment: BulkCommentInput;
};


export type MutationCreateCommentArgs = {
  comment?: InputMaybe<CommentInput>;
};


export type MutationCreateEntitySuppressionConfigurationArgs = {
  create_config?: InputMaybe<CreateEntitySuppressionConfigurationInput>;
  tenant: Scalars['String']['input'];
};


export type MutationCreateQueryJobArgs = {
  clientSessionId: Scalars['String']['input'];
  queryInputJob: QueryInputJob;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type MutationCreateQueryJobAndPollArgs = {
  clientSessionId: Scalars['String']['input'];
  queryInputJob: QueryInputJob;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteApiKeyDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  comment?: InputMaybe<CommentInput>;
};


export type MutationDeleteEdrConfigurationArgs = {
  provider_name: EdrConfigurationType;
};


export type MutationDeleteEntitySuppressionConfigurationArgs = {
  tenant: Scalars['String']['input'];
};


export type MutationDeleteEscalationConfigurationsArgs = {
  escalation_configuration_ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteExporterArgs = {
  exporter_id: ExporterIdInput;
};


export type MutationDeleteFeatureMetadataArgs = {
  feature_name: Scalars['String']['input'];
};


export type MutationDeleteIdentityProviderArgs = {
  provider_name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteModelDeploymentArgs = {
  model_name: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  tag_id: Scalars['String']['input'];
};


export type MutationDeleteUsersArgs = {
  usernames: Array<Scalars['String']['input']>;
};


export type MutationDeleteWhitelistedEntityArgs = {
  entity_name: Scalars['String']['input'];
};


export type MutationEditCommentArgs = {
  comment?: InputMaybe<CommentInput>;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationEnableDisableUserPoolAppClientIdpArgs = {
  enable: Scalars['Boolean']['input'];
};


export type MutationEnableDisableUsersArgs = {
  disable: Scalars['Boolean']['input'];
  usernames: Array<Scalars['String']['input']>;
};


export type MutationEscalateDetectionsArgs = {
  escalate_detections_info: Array<EscalateDetectionInput>;
};


export type MutationLogOperationArgs = {
  input: LogOperationInput;
};


export type MutationPerformEdrActionArgs = {
  action: EntityAction;
  edr_device_input: EdrDeviceInput;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPopulateModelArgs = {
  config?: InputMaybe<Scalars['JSONSTRING']['input']>;
  feature_data?: InputMaybe<Scalars['JSONSTRING']['input']>;
  model_id: Scalars['String']['input'];
};


export type MutationPullEntityEdrStatusArgs = {
  entity_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveExcludedEntitiesFromAlertMetadataArgs = {
  items: Array<InputMaybe<ExcludedEntityInput>>;
};


export type MutationRemoveIdpDomainArgs = {
  idp_domain: Scalars['String']['input'];
};


export type MutationRotateApiKeyDefinitionArgs = {
  end_ts?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  start_ts?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSaveEscalationConfigurationsArgs = {
  escalation_configurations: Array<EscalationConfigurationInput>;
};


export type MutationSaveExporterArgs = {
  input: ExporterInput;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationSetAlertActiveStatusArgs = {
  items: Array<InputMaybe<AlertMetadataInput>>;
};


export type MutationSetAlertAndDetectionTenantConfigsArgs = {
  tenant?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetAlertStatusBySearchTermArgs = {
  items: Array<InputMaybe<SetAlertStatusBySearchTermInput>>;
};


export type MutationSetSeverityOnAlertsArgs = {
  items: Array<SetSeverityOnAlertsInput>;
};


export type MutationSetStatusOnDetectionsArgs = {
  items: Array<SetStatusOnDetectionsInput>;
};


export type MutationStoreEdrConfigurationArgs = {
  config: EdrConfigurationInput;
  provider_name: EdrConfigurationType;
};


export type MutationUpdateEntitySuppressionConfigurationArgs = {
  tenant: Scalars['String']['input'];
  update_config?: InputMaybe<UpdateEntitySuppressionConfigurationInput>;
};


export type MutationUpdateFeatureMetadataArgs = {
  input?: InputMaybe<UpdateFeatureMetadataInput>;
};


export type MutationUpdateIdentityProviderArgs = {
  attribute_mapping?: InputMaybe<Scalars['String']['input']>;
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
  provider_details?: InputMaybe<Scalars['String']['input']>;
  provider_type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateModelDeploymentArgs = {
  input: ModelDeploymentUpdateInput;
};


export type MutationUpdatePrivilegesArgs = {
  input?: InputMaybe<EditPrivilegeInput>;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateTagArgs = {
  input?: InputMaybe<UpdateTagInput>;
};


export type MutationUpdateTenantDisplayNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateWhitelistedEntityArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  entity_name: Scalars['String']['input'];
  entity_type?: InputMaybe<EntityType>;
  tag_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_action?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserUpdateCookieStatusArgs = {
  updates?: InputMaybe<Array<InputMaybe<UpdateUserCookieStatusInput>>>;
};

export type NicHistory = {
  __typename?: 'NICHistory';
  data_source?: Maybe<Scalars['String']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  mac_address?: Maybe<Scalars['String']['output']>;
  obsts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type NameIdMapping = {
  __typename?: 'NameIDMapping';
  alert_name?: Maybe<Scalars['String']['output']>;
  detection_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NoticeAlert = Alert & {
  __typename?: 'NoticeAlert';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  destination_ip?: Maybe<Scalars['String']['output']>;
  dropped?: Maybe<Scalars['String']['output']>;
  dst?: Maybe<Scalars['String']['output']>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  file_desc?: Maybe<Scalars['String']['output']>;
  file_mime_type?: Maybe<Scalars['String']['output']>;
  fuid?: Maybe<Scalars['String']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  msg?: Maybe<Scalars['String']['output']>;
  n?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orig_h?: Maybe<Scalars['String']['output']>;
  orig_p?: Maybe<Scalars['Int']['output']>;
  p?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  peer_descr?: Maybe<Scalars['String']['output']>;
  proto?: Maybe<Scalars['String']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  remote_location?: Maybe<RemoteLocation>;
  resp_h?: Maybe<Scalars['String']['output']>;
  resp_p?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  session_summary?: Maybe<AlertSessionSummary>;
  severity?: Maybe<Scalars['Int']['output']>;
  severity_info?: Maybe<Severity>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_ip?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  suppress_for?: Maybe<Scalars['Float']['output']>;
  system_name?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  uid?: Maybe<Scalars['String']['output']>;
};


export type NoticeAlertSessionSummaryArgs = {
  log_search_client_session_id: Scalars['String']['input'];
};

export type PaginatedApiKeyDefinitions = {
  __typename?: 'PaginatedAPIKeyDefinitions';
  api_key_definitions?: Maybe<Array<Maybe<ApiKeyDefinition>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAlertEntities = {
  __typename?: 'PaginatedAlertEntities';
  alert_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAlertMetadata = {
  __typename?: 'PaginatedAlertMetadata';
  matches?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  metadata?: Maybe<Array<Maybe<AlertMetadata>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAlerts = {
  __typename?: 'PaginatedAlerts';
  alerts?: Maybe<Array<Maybe<Alert>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedComments = {
  __typename?: 'PaginatedComments';
  comments?: Maybe<Array<Maybe<Comment>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<CommentSortParameter>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDetectionSummaries = {
  __typename?: 'PaginatedDetectionSummaries';
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  summaries?: Maybe<Array<Maybe<DetectionSummary>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDetectionSummaryInsights = {
  __typename?: 'PaginatedDetectionSummaryInsights';
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  summary_insights?: Maybe<Array<Maybe<DetectionSummaryInsights>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDetections = {
  __typename?: 'PaginatedDetections';
  detections?: Maybe<Array<Maybe<Detection>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedEdrConfigurations = {
  __typename?: 'PaginatedEDRConfigurations';
  edr_configurations?: Maybe<Array<Maybe<EdrConfiguration>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedEdrEndpointDevices = {
  __typename?: 'PaginatedEdrEndpointDevices';
  edr_endpoint_devices?: Maybe<Array<Maybe<EdrEndpointDevice>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedEntityEdrStatuses = {
  __typename?: 'PaginatedEntityEdrStatuses';
  entity_edr_statuses?: Maybe<Array<Maybe<EntityEdrStatusWithTimestamp>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedEntityInput = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};

export type PaginatedEscalationConfigurations = {
  __typename?: 'PaginatedEscalationConfigurations';
  escalation_configurations?: Maybe<Array<Maybe<EscalationConfiguration>>>;
  filter?: Maybe<EscalationConfigurationFilter>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortingParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedExcludedEntities = {
  __typename?: 'PaginatedExcludedEntities';
  excluded_entities?: Maybe<Array<Maybe<ExcludedEntity>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedNicHistory = {
  __typename?: 'PaginatedNICHistory';
  as_of?: Maybe<Scalars['Float']['output']>;
  max_results?: Maybe<Scalars['Int']['output']>;
  nic_histories?: Maybe<Array<Maybe<NicHistory>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
  use_cache?: Maybe<Scalars['Boolean']['output']>;
};

export type PaginatedQueryJobResult = {
  __typename?: 'PaginatedQueryJobResult';
  after_event_size?: Maybe<Scalars['Int']['output']>;
  before_event_size?: Maybe<Scalars['Int']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offset_event_id?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedUserHistory = {
  __typename?: 'PaginatedUserHistory';
  as_of?: Maybe<Scalars['Float']['output']>;
  max_results?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
  use_cache?: Maybe<Scalars['Boolean']['output']>;
  user_histories?: Maybe<Array<Maybe<UserHistory>>>;
};

export type PaginationType = {
  __typename?: 'PaginationType';
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type PaloAltoNetworksConfiguration = EdrConfiguration & {
  __typename?: 'PaloAltoNetworksConfiguration';
  access_key?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  edr_action_enabled?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  polling_seconds?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  provider_name?: Maybe<EdrConfigurationType>;
  region?: Maybe<Scalars['String']['output']>;
  secret_key?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type PaloAltoNetworksConfigurationInput = {
  access_key: Scalars['String']['input'];
  bucket: Scalars['String']['input'];
  edr_action_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  polling_seconds: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  secret_key: Scalars['String']['input'];
};

export enum Pipeline {
  Dip = 'Dip',
  Domain = 'Domain',
  Hostname = 'Hostname',
  Hpa = 'Hpa',
  Request = 'Request',
  Sip = 'Sip',
  SipDip = 'SipDip',
  SipDomain = 'SipDomain',
  User = 'User',
  UserAccess = 'UserAccess'
}

export type Playbook = {
  __typename?: 'Playbook';
  assessment_summary?: Maybe<Array<Maybe<AssessmentStep>>>;
};

export type PreprocessingFilters = {
  __typename?: 'PreprocessingFilters';
  predict?: Maybe<Array<Maybe<PreprocessingFiltersPredict>>>;
  train?: Maybe<Array<Maybe<PreprocessingFiltersTrain>>>;
};

export type PreprocessingFiltersPredict = {
  __typename?: 'PreprocessingFiltersPredict';
  filter?: Maybe<Scalars['String']['output']>;
};

export type PreprocessingFiltersTrain = {
  __typename?: 'PreprocessingFiltersTrain';
  filter?: Maybe<Scalars['String']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
};

export type PrimaryContact = {
  __typename?: 'PrimaryContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  describeIdentityProvider?: Maybe<IdpDescription>;
  getAPIKeyDefinition?: Maybe<ApiKeyDefinition>;
  getAlertAndDetectionTenantConfigs?: Maybe<ConfigResponse>;
  getAlertMetadata?: Maybe<PaginatedAlertMetadata>;
  getAlerts?: Maybe<PaginatedAlerts>;
  getAppConfigurations?: Maybe<SuccessOutput>;
  getAssociatedDetectionForAlert?: Maybe<Scalars['String']['output']>;
  getChartTimelineFilters?: Maybe<FilterResponse>;
  getComment?: Maybe<Comment>;
  getComments?: Maybe<Array<Maybe<Comment>>>;
  getCommentsByEntityNamePaginated?: Maybe<PaginatedComments>;
  getCommentsForParentPaginated?: Maybe<PaginatedComments>;
  getConfiguredSensorStatus?: Maybe<ConfiguredSensorOutput>;
  getConsolidatedEntityTriageReports?: Maybe<Array<Maybe<ConsolidatedEntityTriageReport>>>;
  getCorelightBlogs?: Maybe<Array<Maybe<BlogOutput>>>;
  getCurrentDetectionTimelineSummary?: Maybe<DetectionAlertGroupCountSummary>;
  getDetectionDestinationTimelineSummary?: Maybe<DetectionAlertGroupCountSummary>;
  getDetectionMethodSummary?: Maybe<Array<Maybe<DetectionMethodBucket>>>;
  getDetectionMitreSummary?: Maybe<Array<Maybe<DetectionTacticSummary>>>;
  getDetectionPeriodSummary?: Maybe<DetectionPeriodSummary>;
  getDetectionSourceDestinationTimelineSummary?: Maybe<DetectionAlertGroupCountSummary>;
  getDetectionSourceTimelineSummary?: Maybe<DetectionAlertGroupCountSummary>;
  getDetections?: Maybe<PaginatedDetections>;
  getEDRConfiguration?: Maybe<EdrConfiguration>;
  getEDRConfigurations?: Maybe<PaginatedEdrConfigurations>;
  getEdrEndpointDevices?: Maybe<PaginatedEdrEndpointDevices>;
  /** @deprecated Use `getEdrEndpointDevices` instead. */
  getEdrPayload?: Maybe<EdrPayload>;
  getEntityDetectionTimelinePaginated?: Maybe<EntityDetectionTimeline>;
  getEntityEdrStatus?: Maybe<EntityEdrStatusWithTimestamp>;
  getEntitySuppressionConfiguration?: Maybe<EntitySuppressionConfiguration>;
  getEscalationConfiguration?: Maybe<EscalationConfiguration>;
  getExporter?: Maybe<Exporter>;
  getExporters?: Maybe<Array<Exporter>>;
  getFeatureMetadata?: Maybe<Array<Maybe<FeatureMetadata>>>;
  getFirstMostSevereAndLatestDetectionsByEntityName?: Maybe<DetectionsByEntityNameResult>;
  getGeneralSettings?: Maybe<TenantGeneralSettings>;
  getHumioDashboards?: Maybe<HumioDomainOutput>;
  getIdentityIncidentsByUser?: Maybe<Array<Maybe<IdentityIncident>>>;
  getIdentityUsers?: Maybe<EntraIdentityUserDoc>;
  getIdpDomains?: Maybe<IdpDomains>;
  getKinesisConnectionDetails?: Maybe<KinesisConnectionDetails>;
  getLicenseInfo?: Maybe<LicenseInfo>;
  getModelDeployment?: Maybe<ModelDeployment>;
  getModelDeployments?: Maybe<Array<Maybe<ModelDeployment>>>;
  getModelSummaries?: Maybe<Array<Maybe<ModelSummary>>>;
  getNicHistoryForEndpointDeviceEntity?: Maybe<PaginatedNicHistory>;
  getPreSignedUrl?: Maybe<Scalars['String']['output']>;
  getPrivileges?: Maybe<Scalars['JSONSTRING']['output']>;
  getTags?: Maybe<Array<Maybe<Tag>>>;
  getTenantPrivileges?: Maybe<Scalars['JSONSTRING']['output']>;
  getTopDetectionEntitiesInsightsPaginated?: Maybe<PaginatedDetectionSummaryInsights>;
  getTopDetectionEntitiesPaginated?: Maybe<PaginatedDetectionSummaries>;
  getTopDetectionsByDetectionGroupsPerEntity?: Maybe<DetectionsByDetectionGroupsPerEntity>;
  getTopDetectionsRawPaginated?: Maybe<PaginatedDetectionSummaries>;
  getTriageEvidenceDetails?: Maybe<TriageEvidenceDetails>;
  getUserCookieAcceptance?: Maybe<Array<Maybe<UserCookieStatus>>>;
  getUserHistoryForEndpointDeviceEntity?: Maybe<PaginatedUserHistory>;
  getUserLogs?: Maybe<UserLogs>;
  getUserSigninHistory?: Maybe<EntraSigninHistoryResult>;
  getUserTcAcceptance?: Maybe<UserSuccessOutput>;
  listAPIKeyDefinitions?: Maybe<PaginatedApiKeyDefinitions>;
  listGroups?: Maybe<Array<Maybe<Group>>>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  pollQueryJob?: Maybe<QueryJobResult>;
  queryAlertMetadataExcludedEntitiesPaginated?: Maybe<PaginatedExcludedEntities>;
  queryAlertMetadataPaginated?: Maybe<PaginatedAlertMetadata>;
  queryAlertsPaginated?: Maybe<PaginatedAlerts>;
  queryDetectionsEntitiesSuggestions?: Maybe<EntitySuggestions>;
  queryDetectionsFieldSuggestions?: Maybe<Array<Scalars['String']['output']>>;
  queryDetectionsPaginated?: Maybe<PaginatedDetections>;
  queryEscalationConfigurations?: Maybe<PaginatedEscalationConfigurations>;
  simpleSearchQuery?: Maybe<SimpleQueryJobResult>;
  verifyEDRConfiguration?: Maybe<VerifiedEdrConfiguration>;
  verifyEscalationConfiguration?: Maybe<VerifiedEscalationConfiguration>;
};


export type QueryGetApiKeyDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAlertAndDetectionTenantConfigsArgs = {
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAlertMetadataArgs = {
  items: Array<InputMaybe<GetAlertMetadataInput>>;
};


export type QueryGetAlertsArgs = {
  items: Array<InputMaybe<GetAlertInput>>;
};


export type QueryGetAssociatedDetectionForAlertArgs = {
  alert_id: Scalars['String']['input'];
};


export type QueryGetChartTimelineFiltersArgs = {
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>>>;
  dest_offset?: InputMaybe<Scalars['Int']['input']>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  entity_name?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source_dest_pair_offset?: InputMaybe<Scalars['Int']['input']>;
  source_offset?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCommentArgs = {
  comment_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCommentsArgs = {
  comment_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCommentsByEntityNamePaginatedArgs = {
  end_ts: Scalars['Float']['input'];
  entity_name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommentSortParameterInput>;
  start_ts: Scalars['Float']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCommentsForParentPaginatedArgs = {
  end_ts?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<CommentParentInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CommentSortParameterInput>>>;
  start_ts?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetConsolidatedEntityTriageReportsArgs = {
  tenant_entity_input?: InputMaybe<TenantEntityIdInput>;
  tenant_report_id_list?: InputMaybe<Array<TenantReportIdInput>>;
};


export type QueryGetCorelightBlogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCurrentDetectionTimelineSummaryArgs = {
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>>>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDetectionDestinationTimelineSummaryArgs = {
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>>>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  entity_name?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDetectionMethodSummaryArgs = {
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDetectionMitreSummaryArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetDetectionPeriodSummaryArgs = {
  curr_period: TimeIntervalInput;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prev_period?: InputMaybe<TimeIntervalInput>;
};


export type QueryGetDetectionSourceDestinationTimelineSummaryArgs = {
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>>>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDetectionSourceTimelineSummaryArgs = {
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>>>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  entity_name?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDetectionsArgs = {
  detection_ids: Array<DetectionId>;
};


export type QueryGetEdrConfigurationArgs = {
  provider_name: EdrConfigurationType;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEdrConfigurationsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  tenant: Scalars['String']['input'];
};


export type QueryGetEdrEndpointDevicesArgs = {
  edr_endpoint_device_inputs: Array<EdrEndpointDeviceInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEdrPayloadArgs = {
  alert_entity_info?: InputMaybe<AlertEntityInfoInput>;
  as_of?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityDetectionTimelinePaginatedArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant_entity?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityEdrStatusArgs = {
  entity_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntitySuppressionConfigurationArgs = {
  tenant: Scalars['String']['input'];
};


export type QueryGetEscalationConfigurationArgs = {
  escalation_configuration_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExporterArgs = {
  exporter_id: ExporterIdInput;
};


export type QueryGetFeatureMetadataArgs = {
  input?: InputMaybe<FeatureMetaDataGetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFirstMostSevereAndLatestDetectionsByEntityNameArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHumioDashboardsArgs = {
  humioSessionToken: Scalars['String']['input'];
};


export type QueryGetIdentityIncidentsByUserArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider_name: EdrConfigurationType;
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type QueryGetIdentityUsersArgs = {
  input: EntraIdentityUserInput;
  provider_name: EdrConfigurationType;
};


export type QueryGetModelDeploymentArgs = {
  model_name: Scalars['String']['input'];
};


export type QueryGetModelDeploymentsArgs = {
  input: ModelDeploymentsGetInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetModelSummariesArgs = {
  model_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetNicHistoryForEndpointDeviceEntityArgs = {
  as_of?: InputMaybe<Scalars['Float']['input']>;
  entity?: InputMaybe<EntityIdInput>;
  max_results?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  use_cache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPreSignedUrlArgs = {
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  object_name: Scalars['String']['input'];
};


export type QueryGetTagsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetTenantPrivilegesArgs = {
  tenant_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTopDetectionEntitiesInsightsPaginatedArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  include_ai_insights?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTopDetectionEntitiesPaginatedArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetTopDetectionsByDetectionGroupsPerEntityArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  group_by: DetectionGroups;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  tenant_entity?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTopDetectionsRawPaginatedArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetTriageEvidenceDetailsArgs = {
  evidence: EvidenceInput;
  tenant: Scalars['String']['input'];
};


export type QueryGetUserHistoryForEndpointDeviceEntityArgs = {
  as_of?: InputMaybe<Scalars['Float']['input']>;
  entity?: InputMaybe<EntityIdInput>;
  max_results?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  use_cache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetUserLogsArgs = {
  input: GetUserLogsInput;
};


export type QueryGetUserSigninHistoryArgs = {
  input: EntraSigninHistorySearchInput;
  provider_name: EdrConfigurationType;
};


export type QueryListApiKeyDefinitionsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListUsersArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  tenants?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPollQueryJobArgs = {
  clientSessionId: Scalars['String']['input'];
  queryJobId: Scalars['String']['input'];
};


export type QueryQueryAlertMetadataExcludedEntitiesPaginatedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type QueryQueryAlertMetadataPaginatedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type QueryQueryAlertsPaginatedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type QueryQueryDetectionsEntitiesSuggestionsArgs = {
  entity_categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entity_name_prefix?: InputMaybe<Scalars['String']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQueryDetectionsFieldSuggestionsArgs = {
  collapse_field?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type QueryQueryDetectionsPaginatedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
};


export type QueryQueryEscalationConfigurationsArgs = {
  filter?: InputMaybe<EscalationConfigurationFilterInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortingParameterInput>>>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySimpleSearchQueryArgs = {
  clientSessionId: Scalars['String']['input'];
  end: Scalars['String']['input'];
  ingestEnd?: InputMaybe<Scalars['String']['input']>;
  ingestStart?: InputMaybe<Scalars['String']['input']>;
  languageVersion?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>>>;
  start: Scalars['String']['input'];
  tenantsForQuery?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZoneOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifyEdrConfigurationArgs = {
  config: EdrConfigurationInput;
  provider_name: EdrConfigurationType;
};


export type QueryVerifyEscalationConfigurationArgs = {
  escalation_configuration: EscalationConfigurationInput;
};

export type QueryInputJob = {
  allowEventSkipping?: InputMaybe<Scalars['Boolean']['input']>;
  around?: InputMaybe<AroundInput>;
  end?: InputMaybe<Scalars['String']['input']>;
  ingestEnd?: InputMaybe<Scalars['String']['input']>;
  ingestStart?: InputMaybe<Scalars['String']['input']>;
  isAlertQuery?: InputMaybe<Scalars['Boolean']['input']>;
  isInteractive?: InputMaybe<Scalars['Boolean']['input']>;
  languageVersion?: InputMaybe<Scalars['String']['input']>;
  queryStringWithoutSortSize: Scalars['String']['input'];
  showQueryEventDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  tenantsForQuery?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timeZoneOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  useIngestTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryJobResult = {
  __typename?: 'QueryJobResult';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  query_job_id?: Maybe<Scalars['String']['output']>;
};

export type RecommendedActionsInfo = {
  __typename?: 'RecommendedActionsInfo';
  recommended_actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  to_isolate_entity?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoteLocation = {
  __typename?: 'RemoteLocation';
  city?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  lattitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ScoreDistribution = {
  __typename?: 'ScoreDistribution';
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type SendEmailInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  extra_kwargs?: InputMaybe<Scalars['JSONSTRING']['input']>;
};

export enum ServiceNameEnum {
  Servicenow = 'servicenow'
}

export type ServiceNowEscalationConfiguration = EscalationConfiguration & {
  __typename?: 'ServiceNowEscalationConfiguration';
  enabled: Scalars['Boolean']['output'];
  escalation_configuration_id: Scalars['String']['output'];
  instance_name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  service_name: ServiceNameEnum;
  table_name?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ServiceNowEscalationConfigurationInput = {
  instance_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  table_name: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SetAlertStatusBySearchTermFiltersInput = {
  active: Array<InputMaybe<Scalars['Boolean']['input']>>;
  severity: Array<InputMaybe<SetAlertStatusScore>>;
  types: Array<InputMaybe<SetAlertStatusType>>;
};

export type SetAlertStatusBySearchTermInput = {
  active: Scalars['Boolean']['input'];
  filters?: InputMaybe<SetAlertStatusBySearchTermFiltersInput>;
  search_term: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type SetAlertStatusBySearchTermResult = {
  __typename?: 'SetAlertStatusBySearchTermResult';
  tenant: Scalars['String']['output'];
  updated_record_count: Scalars['Int']['output'];
};

export enum SetAlertStatusScore {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum SetAlertStatusType {
  Anomaly = 'anomaly',
  CustomSearchRule = 'custom_search_rule',
  MlResults = 'ml_results',
  Notice = 'notice',
  SuricataCorelight = 'suricata_corelight',
  YaraCorelight = 'yara_corelight'
}

export type SetSeverityOnAlertsInput = {
  content_id: Scalars['String']['input'];
  severity_info: SeverityInfoInput;
  tenant: Scalars['String']['input'];
  updated_timestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type SetStatusOnDetectionsInput = {
  detection_id: Scalars['String']['input'];
  detection_status: DetectionStatus;
  tenant: Scalars['String']['input'];
  update_info: DetectionUpdateInfoInput;
};

export type Severity = {
  __typename?: 'Severity';
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SeverityInfo = {
  __typename?: 'SeverityInfo';
  custom_severity?: Maybe<Scalars['Int']['output']>;
  custom_severity_enabled?: Maybe<Scalars['Boolean']['output']>;
  default_severity?: Maybe<Scalars['Int']['output']>;
  last_updated_by_user_alias?: Maybe<Scalars['String']['output']>;
  last_updated_by_username?: Maybe<Scalars['String']['output']>;
  last_updated_timestamp?: Maybe<Scalars['Float']['output']>;
};

export type SeverityInfoInput = {
  custom_severity?: InputMaybe<Scalars['Int']['input']>;
  custom_severity_enabled: Scalars['Boolean']['input'];
};

export type SimpleQueryJobResult = {
  __typename?: 'SimpleQueryJobResult';
  events?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Array<Maybe<SortParameter>>>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export enum SortByEnum {
  EscalationConfigurationId = 'escalation_configuration_id',
  ServiceName = 'service_name'
}

export enum SortDirEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortParameter = {
  __typename?: 'SortParameter';
  sort_by: Scalars['String']['output'];
  sort_dir: Scalars['String']['output'];
};

export type SortParameterInput = {
  sort_by: Scalars['String']['input'];
  sort_dir: Scalars['String']['input'];
};

export type SortingParameter = {
  __typename?: 'SortingParameter';
  sort_by: SortByEnum;
  sort_dir: SortDirEnum;
};

export type SortingParameterInput = {
  sort_by: SortByEnum;
  sort_dir: SortDirEnum;
};

export type SplunkHecLogsExporter = Exporter & {
  __typename?: 'SplunkHecLogsExporter';
  enabled: Scalars['Boolean']['output'];
  exporter: ExporterType;
  exporter_id: Scalars['String']['output'];
  hec_url: Scalars['String']['output'];
  index?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  tls: ExporterTlsInfo;
  token?: Maybe<Scalars['String']['output']>;
};

export type SplunkHecLogsExporterInput = {
  hec_url: Scalars['String']['input'];
  index: Scalars['String']['input'];
  tls: ExporterTlsInfoInput;
  token: Scalars['String']['input'];
};

export type SuccessBody = {
  __typename?: 'SuccessBody';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuccessOutput = {
  __typename?: 'SuccessOutput';
  body?: Maybe<SuccessBody>;
  status_code?: Maybe<Scalars['Int']['output']>;
};

export type SuricataAlert = Alert & {
  __typename?: 'SuricataAlert';
  action?: Maybe<Scalars['String']['output']>;
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  category?: Maybe<Scalars['String']['output']>;
  community_id?: Maybe<Scalars['String']['output']>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  destination_ip?: Maybe<Scalars['String']['output']>;
  destination_port?: Maybe<Scalars['Int']['output']>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  flow_id?: Maybe<Scalars['Float']['output']>;
  gid?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Array<Maybe<SuricataMetadata>>>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  payload?: Maybe<Scalars['String']['output']>;
  payload_summary?: Maybe<Scalars['String']['output']>;
  pcap_cnt?: Maybe<Scalars['Int']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  rev?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  session_summary?: Maybe<AlertSessionSummary>;
  severity?: Maybe<Scalars['Int']['output']>;
  signature_id?: Maybe<Scalars['String']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_ip?: Maybe<Scalars['String']['output']>;
  source_port?: Maybe<Scalars['Int']['output']>;
  suri_id?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  tx_id?: Maybe<Scalars['Int']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  xff?: Maybe<Scalars['String']['output']>;
};


export type SuricataAlertSessionSummaryArgs = {
  log_search_client_session_id: Scalars['String']['input'];
};

export type SuricataMetadata = {
  __typename?: 'SuricataMetadata';
  key?: Maybe<Scalars['String']['output']>;
  val?: Maybe<Scalars['String']['output']>;
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  humio_root?: Maybe<Scalars['String']['output']>;
};

export type TableStringFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  alert?: Maybe<Scalars['Boolean']['output']>;
  create_time?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labels_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  system_tag?: Maybe<Scalars['Boolean']['output']>;
  tactic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  update_time?: Maybe<Scalars['String']['output']>;
  use_case?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TagInput = {
  alert: Scalars['Boolean']['input'];
  create_time?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  labels_count?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  severity: Scalars['Int']['input'];
  system_tag: Scalars['Boolean']['input'];
  tactic: Scalars['String']['input'];
  type: Scalars['String']['input'];
  update_time?: InputMaybe<Scalars['String']['input']>;
  use_case: Array<Scalars['String']['input']>;
};

export type TenantDisplayNameInfo = {
  __typename?: 'TenantDisplayNameInfo';
  display_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['Int']['output']>;
};

export type TenantEntityIdInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  entity_id: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  tenant: Scalars['String']['input'];
};

export type TenantGeneralSettings = {
  __typename?: 'TenantGeneralSettings';
  alertExport?: Maybe<Scalars['Boolean']['output']>;
  chatgpt?: Maybe<Scalars['Boolean']['output']>;
  chatgpt_agentic_triage?: Maybe<Scalars['Boolean']['output']>;
  detection_auto_close_config?: Maybe<DetectionAutoCloseConfig>;
  tenant_display_name_info?: Maybe<TenantDisplayNameInfo>;
};

export type TenantMember = {
  __typename?: 'TenantMember';
  display_name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

export type TenantReportIdInput = {
  report_id: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type TimeIntervalInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  alert_id?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<Maybe<TimelineEventEntity>>>;
  event_type?: Maybe<Scalars['String']['output']>;
  pattern_id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type TimelineEventEntity = {
  __typename?: 'TimelineEventEntity';
  primary_display_name?: Maybe<Scalars['String']['output']>;
};

export type TrainingSetDates = {
  __typename?: 'TrainingSetDates';
  end_date?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
};

export type TriageEvidenceDetails = {
  __typename?: 'TriageEvidenceDetails';
  evidence: Scalars['String']['output'];
  message: Scalars['String']['output'];
  pivot_query?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
};

export type UpdateEntitySuppressionConfigurationInput = {
  fields_to_suppress: Array<AlertField>;
  file_content?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  reason_for_suppression: Scalars['String']['input'];
  update_file?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFeatureMetadataInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  data_type?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_feature?: InputMaybe<Scalars['Boolean']['input']>;
  log_type?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pipeline?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileInput = {
  alias: Scalars['String']['input'];
};

export type UpdateTagInput = {
  alert?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['Int']['input']>;
  tactic?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserCookieStatusInput = {
  cookie_status: CookieStatus;
  cookie_type: CookieType;
};

export type User = {
  __typename?: 'User';
  alias?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  is_sso_user?: Maybe<Scalars['Boolean']['output']>;
  last_login_at?: Maybe<Scalars['Int']['output']>;
  local_auth_enabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  super_admin?: Maybe<Scalars['Boolean']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserCookieStatus = {
  __typename?: 'UserCookieStatus';
  cookie_type?: Maybe<CookieType>;
  cookies_accepted?: Maybe<Scalars['Boolean']['output']>;
  cookies_accepted_date?: Maybe<Scalars['Float']['output']>;
  cookies_accepted_expiration?: Maybe<Scalars['Float']['output']>;
};

export type UserHistory = {
  __typename?: 'UserHistory';
  data_source?: Maybe<Scalars['String']['output']>;
  identity_user?: Maybe<CrowdStrikeIdentityUserInfo>;
  obsts?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserLog = {
  __typename?: 'UserLog';
  message?: Maybe<Scalars['JSONSTRING']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenant_info?: Maybe<UsersTenantInfo>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type UserLogFilterInput = {
  audit_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  user_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserLogs = {
  __typename?: 'UserLogs';
  log?: Maybe<Array<Maybe<UserLog>>>;
  offset?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
};

export type UserSuccessBody = {
  __typename?: 'UserSuccessBody';
  data?: Maybe<Scalars['JSONSTRING']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSuccessOutput = {
  __typename?: 'UserSuccessOutput';
  body?: Maybe<UserSuccessBody>;
  status_code?: Maybe<Scalars['Int']['output']>;
};

export type UsersTenantInfo = {
  __typename?: 'UsersTenantInfo';
  tenant_display_name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
};

export enum Verdict {
  LikelyBenign = 'LIKELY_BENIGN',
  LikelyMalicious = 'LIKELY_MALICIOUS',
  Suspicious = 'SUSPICIOUS',
  Undetermined = 'UNDETERMINED'
}

export type VerifiedEdrConfiguration = {
  __typename?: 'VerifiedEDRConfiguration';
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifiedEscalationConfiguration = {
  __typename?: 'VerifiedEscalationConfiguration';
  verified: Scalars['Boolean']['output'];
};

export type WhitelistedEntity = {
  __typename?: 'WhitelistedEntity';
  create_time?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<EntityType>;
  tag_id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WhitelistedEntityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entity_name: Scalars['String']['input'];
  entity_type: EntityType;
  tag_id: Array<InputMaybe<Scalars['String']['input']>>;
};

export type YaraAlert = Alert & {
  __typename?: 'YaraAlert';
  alert_disposition?: Maybe<AlertDisposition>;
  alert_entity?: Maybe<AlertEntity>;
  alert_id: Scalars['String']['output'];
  alert_info?: Maybe<AlertInfo>;
  alert_keys?: Maybe<AlertKeys>;
  alert_timestamp?: Maybe<AlertTimestamp>;
  destination_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  destination_ip?: Maybe<Scalars['String']['output']>;
  event_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  false_positive?: Maybe<Scalars['Boolean']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  fuid?: Maybe<Scalars['String']['output']>;
  md5?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  mitre_tactics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mitre_techniques?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orig_h?: Maybe<Scalars['String']['output']>;
  orig_p?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  related_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  resp_h?: Maybe<Scalars['String']['output']>;
  resp_p?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  session_summary?: Maybe<AlertSessionSummary>;
  severity?: Maybe<Scalars['Int']['output']>;
  sha1?: Maybe<Scalars['String']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_entities?: Maybe<Array<Maybe<AlertEntity>>>;
  source_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_ip?: Maybe<Scalars['String']['output']>;
  system_name?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  uid?: Maybe<Scalars['String']['output']>;
};


export type YaraAlertSessionSummaryArgs = {
  log_search_client_session_id: Scalars['String']['input'];
};

export type AddIdpDomainMutationVariables = Exact<{
  idp_domain: Scalars['String']['input'];
}>;


export type AddIdpDomainMutation = { __typename?: 'Mutation', addIdpDomain?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type ConfigureAndEnableIdentityProviderMutationVariables = Exact<{
  attribute_mapping: Scalars['String']['input'];
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  provider_details: Scalars['String']['input'];
  provider_type: Scalars['String']['input'];
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfigureAndEnableIdentityProviderMutation = { __typename?: 'Mutation', configureAndEnableIdentityProvider?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type ConfigureIdentityProviderMutationVariables = Exact<{
  attribute_mapping: Scalars['String']['input'];
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  provider_details: Scalars['String']['input'];
  provider_type: Scalars['String']['input'];
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfigureIdentityProviderMutation = { __typename?: 'Mutation', configureIdentityProvider?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type CreateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  end_ts?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createAPIKeyDefinition?: { __typename?: 'APIKeyDefinition', api_key?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type DeleteIdentityProviderMutationVariables = Exact<{
  provider_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteIdentityProviderMutation = { __typename?: 'Mutation', deleteIdentityProvider?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type DeleteUsersMutationVariables = Exact<{
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type DescribeIdentityProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type DescribeIdentityProviderQuery = { __typename?: 'Query', describeIdentityProvider?: { __typename?: 'IdpDescription', attribute_mapping?: any | null, created_at?: number | null, idp_identifiers?: Array<string | null> | null, last_modified?: number | null, is_sso_enabled?: boolean | null, provider_details?: any | null, idp_user_role_mapping?: any | null } | null };

export type EditUserMutationVariables = Exact<{
  input: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type EnableDisableUserPoolAppClientIdpMutationVariables = Exact<{
  enable: Scalars['Boolean']['input'];
}>;


export type EnableDisableUserPoolAppClientIdpMutation = { __typename?: 'Mutation', enableDisableUserPoolAppClientIdp?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type EnableDisableUsersMutationVariables = Exact<{
  disable: Scalars['Boolean']['input'];
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EnableDisableUsersMutation = { __typename?: 'Mutation', enableDisableUsers?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type GetApiKeysQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetApiKeysQuery = { __typename?: 'Query', listAPIKeyDefinitions?: { __typename?: 'PaginatedAPIKeyDefinitions', offset?: number | null, size?: number | null, total_count?: number | null, api_key_definitions?: Array<{ __typename?: 'APIKeyDefinition', id?: string | null, name?: string | null, updated_ts?: number | null, created_ts?: number | null, created_by_alias?: string | null, end_ts?: number | null } | null> | null } | null };

export type GetConfiguredSensorStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfiguredSensorStatusQuery = { __typename?: 'Query', getConfiguredSensorStatus?: { __typename?: 'ConfiguredSensorOutput', configured?: boolean | null } | null };

export type GetGeneralSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneralSettingsQuery = { __typename?: 'Query', getGeneralSettings?: { __typename?: 'TenantGeneralSettings', tenant_display_name_info?: { __typename?: 'TenantDisplayNameInfo', display_name?: string | null, updated_on?: number | null, updated_by?: string | null } | null } | null };

export type GetIdpDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdpDomainsQuery = { __typename?: 'Query', getIdpDomains?: { __typename?: 'IdpDomains', domains: Array<string>, pagination?: { __typename?: 'PaginationType', offset?: number | null, size?: number | null, total_items?: number | null } | null } | null };

export type GetKinesisConnectionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKinesisConnectionDetailsQuery = { __typename?: 'Query', getKinesisConnectionDetails?: { __typename?: 'KinesisConnectionDetails', access_key?: string | null, aws_region?: string | null, secret_key?: string | null, stream_name?: string | null } | null };

export type GetLicenseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLicenseInfoQuery = { __typename?: 'Query', getLicenseInfo?: { __typename?: 'LicenseInfo', end?: number | null, expired?: boolean | null, federation_type?: FederationTypes | null, gbps?: string | null, input_region?: string | null, license_type?: string | null, org?: string | null, retention_days?: number | null, start?: number | null, tenant?: string | null, tenant_location?: string | null, tenant_type?: string | null, display_name?: string | null, members?: Array<{ __typename?: 'TenantMember', display_name?: string | null, tenant_id?: string | null } | null> | null, primary_contact?: { __typename?: 'PrimaryContact', email?: string | null, name?: string | null } | null, system_info?: { __typename?: 'SystemInfo', humio_root?: string | null } | null } | null };

export type GetTenantPrivilegesQueryVariables = Exact<{
  tenant_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTenantPrivilegesQuery = { __typename?: 'Query', getTenantPrivileges?: any | null };

export type ListGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGroupsQuery = { __typename?: 'Query', listGroups?: Array<{ __typename?: 'Group', group_name?: string | null } | null> | null };

export type ListUsersQueryVariables = Exact<{
  tenants: Array<Scalars['String']['input']> | Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers?: Array<{ __typename?: 'User', username?: string | null, alias?: string | null, tenant?: string | null, email?: string | null, is_sso_user?: boolean | null, created_at?: number | null, enabled?: boolean | null, status?: string | null, group?: string | null, local_auth_enabled?: boolean | null } | null> | null };

export type RemoveIdpDomainMutationVariables = Exact<{
  idp_domain: Scalars['String']['input'];
}>;


export type RemoveIdpDomainMutation = { __typename?: 'Mutation', removeIdpDomain?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteAPIKeyDefinition?: { __typename?: 'APIKeyDefinition', id?: string | null } | null };

export type RotateApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  end_ts?: InputMaybe<Scalars['Float']['input']>;
}>;


export type RotateApiKeyMutation = { __typename?: 'Mutation', rotateAPIKeyDefinition?: { __typename?: 'APIKeyDefinition', api_key?: string | null } | null };

export type SendEmailMutationVariables = Exact<{
  input: SendEmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail?: { __typename?: 'SuccessOutput', status_code?: number | null, body?: { __typename?: 'SuccessBody', data?: string | null, message?: string | null, success?: boolean | null } | null } | null };

export type UpdateIdentityProviderMutationVariables = Exact<{
  provider_details?: InputMaybe<Scalars['String']['input']>;
  attribute_mapping?: InputMaybe<Scalars['String']['input']>;
  idp_identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  provider_type?: InputMaybe<Scalars['String']['input']>;
  idp_user_role_mapping?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIdentityProviderMutation = { __typename?: 'Mutation', updateIdentityProvider?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type UpdatePrivilegesMutationVariables = Exact<{
  input: EditPrivilegeInput;
}>;


export type UpdatePrivilegesMutation = { __typename?: 'Mutation', updatePrivileges?: { __typename?: 'SuccessOutput', status_code?: number | null, body?: { __typename?: 'SuccessBody', data?: string | null, message?: string | null, success?: boolean | null } | null } | null };

export type UpdateTenantDisplayNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type UpdateTenantDisplayNameMutation = { __typename?: 'Mutation', updateTenantDisplayName?: { __typename?: 'TenantDisplayNameInfo', display_name?: string | null, updated_by?: string | null, updated_on?: number | null } | null };

export type QueryAlertsAnomalyPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsAnomalyPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename: 'AnomalyAlert', alert_id: string, path?: string | null, system_name?: string | null, uid?: string | null, orig_h?: string | null, source_ip?: string | null, destination_ip?: string | null, usecase?: string | null, usecase_description?: string | null, anomaly_type?: string | null, tenant: string, entity?: string | null, original_entity?: string | null, entity_training_items?: Array<string | null> | null, item?: string | null, item_score?: number | null, item_assoc_entities?: Array<string | null> | null, item_assoc_entities_similarity?: Array<number | null> | null, baselining_start_timestamp?: number | null, baselining_end_timestamp?: number | null, nn1_entities?: Array<string | null> | null, nn1_train_items?: Array<string | null> | null, nn2_entities?: Array<string | null> | null, nn2_train_items?: Array<string | null> | null, nn3_entities?: Array<string | null> | null, nn3_train_items?: Array<string | null> | null, nn4_entities?: Array<string | null> | null, nn4_train_items?: Array<string | null> | null, nn5_entities?: Array<string | null> | null, nn5_train_items?: Array<string | null> | null, nn6_entities?: Array<string | null> | null, nn6_train_items?: Array<string | null> | null, nn7_entities?: Array<string | null> | null, nn7_train_items?: Array<string | null> | null, nn8_entities?: Array<string | null> | null, nn8_train_items?: Array<string | null> | null, nn9_entities?: Array<string | null> | null, nn9_train_items?: Array<string | null> | null, nn10_entities?: Array<string | null> | null, nn10_train_items?: Array<string | null> | null, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_alert_entity?: string | null, tenant_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsAnomalySummaryQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  log_search_client_session_id: Scalars['String']['input'];
}>;


export type QueryAlertsAnomalySummaryQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert', alert_id: string, path?: string | null, system_name?: string | null, uid?: string | null, orig_h?: string | null, source_ip?: string | null, usecase?: string | null, usecase_description?: string | null, anomaly_type?: string | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, session_summary?: { __typename?: 'AlertSessionSummary', ioc?: Array<string | null> | null, alert_summary?: Array<string | null> | null, alert_beacons?: Array<string | null> | null, unusual_findings?: Array<string | null> | null, attack_tactics?: Array<string | null> | null } | null } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type GetAnomalyAlertMetadataQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  content_id: Scalars['String']['input'];
}>;


export type GetAnomalyAlertMetadataQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', id?: string | null, author?: string | null, date?: string | null, title?: string | null, match_meta?: Array<string | null> | null } | null> | null } | null };

export type QueryDetectionsEntitiesSuggestionsQueryVariables = Exact<{
  entity_name_prefix?: InputMaybe<Scalars['String']['input']>;
  entity_categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryDetectionsEntitiesSuggestionsQuery = { __typename?: 'Query', queryDetectionsEntitiesSuggestions?: { __typename?: 'EntitySuggestions', source_entities?: Array<string | null> | null, destination_entities?: Array<string | null> | null } | null };

export type QueryDetectionsFieldSuggestionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  collapse_field: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryDetectionsFieldSuggestionsQuery = { __typename?: 'Query', queryDetectionsFieldSuggestions?: Array<string> | null };

export type AddExcludedEntitiesToAlertMetadataMutationVariables = Exact<{
  items: Array<InputMaybe<ExcludedEntityInput>> | InputMaybe<ExcludedEntityInput>;
}>;


export type AddExcludedEntitiesToAlertMetadataMutation = { __typename?: 'Mutation', addExcludedEntitiesToAlertMetadata?: { __typename?: 'PaginatedExcludedEntities', offset?: number | null, size?: number | null, total_items?: number | null, excluded_entities?: Array<{ __typename?: 'ExcludedEntity', _score?: number | null, content_id?: string | null, entity_id?: string | null, entity_ip?: string | null, entity_ip_range?: string | null, entity_name?: string | null, entity_type?: AlertEntityType | null, tenant?: string | null, created_by?: string | null, created_by_alias?: string | null, created_timestamp?: number | null } | null> | null } | null };

export type AssignDetectionsMutationVariables = Exact<{
  items: Array<AssignDetectionsInput> | AssignDetectionsInput;
}>;


export type AssignDetectionsMutation = { __typename?: 'Mutation', assignDetections?: { __typename?: 'PaginatedDetections', offset?: number | null, size?: number | null, total_items?: number | null, detections?: Array<{ __typename?: 'Detection', created_timestamp: number, detection_id: string, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, total_alert_count: number, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null }, assignment_info?: { __typename?: 'DetectionAssignmentInfo', assigned_at?: number | null, assigned_to_username?: string | null, assigned_to_user_alias?: string | null } | null, detection_timestamp: { __typename?: 'DetectionTimestamp', end?: number | null, start: number }, mitre_mappings?: { __typename?: 'MitreMappings', tactics?: Array<{ __typename?: 'MitreTactics', link?: string | null, name?: string | null, tag?: string | null, techniques?: Array<{ __typename?: 'MitreTechniques', link?: string | null, name?: string | null, tag?: string | null, subtechniques?: Array<{ __typename?: 'MitreSubtechniques', link?: string | null, name?: string | null, tag?: string | null } | null> | null } | null> | null } | null> | null } | null, rank: { __typename?: 'DetectionRank', severity: number }, update_info?: { __typename?: 'DetectionUpdateInfo', last_updated_by?: string | null, last_updated_by_username?: string | null, last_updated_timestamp?: number | null } | null, escalation_data?: { __typename?: 'DetectionEscalationData', escalation_status?: boolean | null, escalated_by_user_alias?: string | null, escalated_timestamp?: number | null, escalation_service_name?: EscalationServiceNameEnum | null } | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null };

export type CreateBulkCommentsForDetectionsMutationVariables = Exact<{
  comment: BulkCommentInput;
}>;


export type CreateBulkCommentsForDetectionsMutation = { __typename?: 'Mutation', createBulkCommentsForDetections: { __typename?: 'BulkCommentsOperationResult', message?: string | null } };

export type CreateCommentMutationVariables = Exact<{
  comment?: InputMaybe<CommentInput>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment?: { __typename?: 'Comment', comment_id?: string | null, created_at?: number | null, updated_at?: number | null, author_alias?: string | null, comment?: string | null, parent?: { __typename?: 'CommentParent', parent_object_id?: string | null, parent_object_type?: CommentParentType | null } | null, replies?: { __typename?: 'PaginatedComments', offset?: number | null, size?: number | null, sort?: Array<{ __typename?: 'CommentSortParameter', direction?: CommentSortDirection | null } | null> | null } | null } | null };

export type GetAlertAndDetectionTenantConfigsQueryVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlertAndDetectionTenantConfigsQuery = { __typename?: 'Query', getAlertAndDetectionTenantConfigs?: { __typename?: 'ConfigResponse', tenant?: string | null, category?: string | null, configs?: Array<{ __typename?: 'ConfigInfo', config_key?: string | null, config_value?: boolean | null } | null> | null } | null };

export type GetAlertMetadataQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', date?: string | null, category?: string | null, cve_reference?: string | null, severity_description?: string | null, active?: boolean | null, author?: string | null, description?: string | null, falsepositives?: Array<string | null> | null, fields?: Array<string | null> | null, id?: string | null, level?: string | null, references?: Array<string | null> | null, severity?: number | null, status?: string | null, tags?: Array<string | null> | null, tenant_alert?: string | null, title?: string | null, rule?: string | null, related?: Array<{ __typename?: 'MetadataRelated', id?: string | null, title?: string | null, type?: string | null } | null> | null, event_generation_strategy?: { __typename?: 'MetadataEventStrategy', attack_probability_threshold?: number | null, method?: string | null, predicted_tag_id?: string | null, alert_sid?: string | null } | null, logsource?: { __typename?: 'MetadataLogSource', category?: string | null, product?: string | null, service?: string | null } | null, mitre_mappings?: { __typename?: 'MitreMappings', tactics?: Array<{ __typename?: 'MitreTactics', link?: string | null, name?: string | null, tag?: string | null, techniques?: Array<{ __typename?: 'MitreTechniques', link?: string | null, name?: string | null, tag?: string | null, subtechniques?: Array<{ __typename?: 'MitreSubtechniques', link?: string | null, name?: string | null, tag?: string | null } | null> | null } | null> | null } | null> | null } | null, severity_info?: { __typename?: 'SeverityInfo', custom_severity?: number | null, custom_severity_enabled?: boolean | null, default_severity?: number | null, last_updated_by_user_alias?: string | null, last_updated_by_username?: string | null, last_updated_timestamp?: number | null } | null, content_doc?: { __typename?: 'AlertDocumentation', significance?: string | null, validation?: string | null, nextsteps?: string | null, queries?: string | null } | null, custom_search_rule?: { __typename?: 'CustomSearchRuleAlertMetadata', query_string?: string | null, query_filter?: string | null, throttle_time?: string | null, time_interval?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataNonSuricataAlertAttackQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataNonSuricataAlertAttackQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', chatbot_chats?: { __typename?: 'AlertMetadataChatbotChats', non_suri_alert_attack?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataNonSuricataAlertTtpQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataNonSuricataAlertTtpQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', chatbot_chats?: { __typename?: 'AlertMetadataChatbotChats', non_suri_alert_ttp?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataSuricataAlertExplainQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataSuricataAlertExplainQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', chatbot_chats?: { __typename?: 'AlertMetadataChatbotChats', suri_alert_explain?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataSuricataInvestigateAlertQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataSuricataInvestigateAlertQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', chatbot_chats?: { __typename?: 'AlertMetadataChatbotChats', suri_investigate_alert?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataDescribeRuleQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataDescribeRuleQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', chatbot_chats?: { __typename?: 'AlertMetadataChatbotChats', suri_describe_rule?: string | null } | null } | null> | null } | null };

export type GetAlertMetadataYaraQueryVariables = Exact<{
  items: Array<InputMaybe<GetAlertMetadataInput>> | InputMaybe<GetAlertMetadataInput>;
}>;


export type GetAlertMetadataYaraQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', id?: string | null, author?: string | null, date?: string | null, title?: string | null, match_meta?: Array<string | null> | null } | null> | null } | null };

export type GetAssociatedDetectionForAlertQueryVariables = Exact<{
  alert_id: Scalars['String']['input'];
}>;


export type GetAssociatedDetectionForAlertQuery = { __typename?: 'Query', getAssociatedDetectionForAlert?: string | null };

export type GetChartTimelineFiltersQueryVariables = Exact<{
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>> | InputMaybe<AlertNameFilterInput>>;
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>> | InputMaybe<DetectionAlertSummarySeverities>>;
  entity_filter?: InputMaybe<EntityFilterInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source_offset?: InputMaybe<Scalars['Int']['input']>;
  dest_offset?: InputMaybe<Scalars['Int']['input']>;
  source_dest_pair_offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChartTimelineFiltersQuery = { __typename?: 'Query', getChartTimelineFilters?: { __typename?: 'FilterResponse', severity_filter?: Array<DetectionAlertSummarySeverities | null> | null, alert_name_filter?: Array<{ __typename?: 'NameIDMapping', alert_name?: string | null, detection_ids?: Array<string | null> | null } | null> | null, entity_filter?: { __typename?: 'EntityFilter', source?: { __typename?: 'EntityObj', source_entities?: Array<string | null> | null, dest_entities?: Array<string | null> | null, offset?: number | null, size?: number | null, total_items?: number | null } | null, dest?: { __typename?: 'EntityObj', source_entities?: Array<string | null> | null, dest_entities?: Array<string | null> | null, offset?: number | null, size?: number | null, total_items?: number | null } | null, source_dest?: { __typename?: 'EntityObj', source_entities?: Array<string | null> | null, dest_entities?: Array<string | null> | null, offset?: number | null, size?: number | null, total_items?: number | null } | null } | null } | null };

export type GetCommentsForParentPaginatedQueryVariables = Exact<{
  parent?: InputMaybe<CommentParentInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CommentSortParameterInput>> | InputMaybe<CommentSortParameterInput>>;
}>;


export type GetCommentsForParentPaginatedQuery = { __typename?: 'Query', getCommentsForParentPaginated?: { __typename?: 'PaginatedComments', total_count?: number | null, offset?: number | null, size?: number | null, comments?: Array<{ __typename?: 'Comment', comment_id?: string | null, comment?: string | null, created_at?: number | null, author_alias?: string | null, parent?: { __typename?: 'CommentParent', parent_object_id?: string | null, parent_object_type?: CommentParentType | null } | null } | null> | null } | null };

export type GetCorelightBlogsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCorelightBlogsQuery = { __typename?: 'Query', getCorelightBlogs?: Array<{ __typename: 'BlogOutput', category?: Array<string | null> | null, dc_creator?: string | null, dc_date?: string | null, description?: string | null, link?: string | null, pub_date?: string | null, title?: string | null } | null> | null };

export type GetDetectionMethodSummaryQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type GetDetectionMethodSummaryQuery = { __typename?: 'Query', getDetectionMethodSummary?: Array<{ __typename?: 'DetectionMethodBucket', detection_method?: string | null, total?: number | null, enabled?: number | null } | null> | null };

export type GetDetectionMitreSummaryQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDetectionMitreSummaryQuery = { __typename?: 'Query', getDetectionMitreSummary?: Array<{ __typename?: 'DetectionTacticSummary', detection_count?: number | null, entity_count?: number | null, first_seen?: number | null, last_seen?: number | null, mitre_attack_tactic?: string | null, mitre_attack_tactic_priority?: number | null, tenant?: string | null, total_detections?: number | null, mitre_attack_techniques?: Array<{ __typename?: 'DetectionTechniqueSummary', detection_count?: number | null, entity_count?: number | null, first_seen?: number | null, last_seen?: number | null, mitre_attack_tactic?: string | null, mitre_attack_tactic_priority?: number | null, mitre_attack_technique?: string | null, tenant?: string | null, total_detections?: number | null } | null> | null } | null> | null };

export type GetDetectionPeriodSummaryQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  prev_start?: InputMaybe<Scalars['Float']['input']>;
  prev_end?: InputMaybe<Scalars['Float']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDetectionPeriodSummaryQuery = { __typename?: 'Query', getDetectionPeriodSummary?: { __typename?: 'DetectionPeriodSummary', count?: { __typename?: 'CurrentPreviousSummary', current?: number | null, pct_chg?: number | null, previous?: number | null } | null, score?: { __typename?: 'ScoreDistribution', avg?: number | null, max?: number | null, min?: number | null } | null, total_alert_categories?: { __typename?: 'CurrentPreviousSummary', current?: number | null, pct_chg?: number | null, previous?: number | null } | null, total_entities?: { __typename?: 'CurrentPreviousSummary', current?: number | null, pct_chg?: number | null, previous?: number | null } | null } | null };

export type GetDetectionTimelineSummaryQueryVariables = Exact<{
  detection_id?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>> | InputMaybe<AlertNameFilterInput>>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>> | InputMaybe<DetectionAlertSummarySeverities>>;
}>;


export type GetDetectionTimelineSummaryQuery = { __typename?: 'Query', getCurrentDetectionTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null, getDetectionDestinationTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null, getDetectionSourceTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null, getDetectionSourceDestinationTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null };

export type GetDetectionsQueryVariables = Exact<{
  detection_ids: Array<DetectionId> | DetectionId;
  dest_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
  source_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
}>;


export type GetDetectionsQuery = { __typename?: 'Query', getDetections?: { __typename?: 'PaginatedDetections', offset?: number | null, size?: number | null, total_items?: number | null, detections?: Array<{ __typename?: 'Detection', created_timestamp: number, detection_id: string, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, tenant: string, total_alert_count: number, logscale_query?: string | null, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null }, assignment_info?: { __typename?: 'DetectionAssignmentInfo', assigned_at?: number | null, assigned_to_username?: string | null, assigned_to_user_alias?: string | null } | null, detection_keys?: { __typename?: 'DetectionKeys', tenant_detection?: string | null, tenant_detection_entity?: string | null, tenant_entity?: string | null } | null, detection_timestamp: { __typename?: 'DetectionTimestamp', end?: number | null, start: number }, rank: { __typename?: 'DetectionRank', is_custom_severity?: boolean | null, severity: number }, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null, update_info?: { __typename?: 'DetectionUpdateInfo', last_updated_by?: string | null, last_updated_timestamp?: number | null } | null, escalation_data?: { __typename?: 'DetectionEscalationData', escalation_status?: boolean | null, escalated_by_user_alias?: string | null, escalated_timestamp?: number | null, escalation_service_name?: EscalationServiceNameEnum | null } | null, paginated_destination_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null, paginated_source_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null };

export type GetTopDetectionsByDetectionGroupsPerEntityQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  tenant_entity: Scalars['String']['input'];
  group_by: DetectionGroups;
}>;


export type GetTopDetectionsByDetectionGroupsPerEntityQuery = { __typename?: 'Query', getTopDetectionsByDetectionGroupsPerEntity?: { __typename: 'DetectionsByDetectionGroupsPerEntity', group_by: DetectionGroups, tenant_entity?: string | null, tenant?: string | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null, data?: Array<{ __typename?: 'DetectionsByDetectionGroupPerEntity', group_key: string, detections_count?: number | null, detections?: Array<{ __typename?: 'Detection', detection_id: string, latest_start_timestamp?: number | null, mitre_tactics?: Array<string | null> | null, mitre_techniques?: Array<string | null> | null, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null }, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null } } | null> | null } | null> | null } | null };

export type GetEntityDetectionTimelinePaginatedQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  tenant_entity?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetEntityDetectionTimelinePaginatedQuery = { __typename?: 'Query', getEntityDetectionTimelinePaginated?: { __typename?: 'EntityDetectionTimeline', entity_name?: string | null, entity_type?: string | null, is_truncated?: boolean | null, offset?: number | null, severity?: number | null, size?: number | null, tenant?: string | null, tenant_entity?: string | null, total_detections?: number | null, total_grouped_entities?: number | null, total_items?: number | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null, data?: Array<{ __typename?: 'EntityDetectionTimelineItem', alert_name?: string | null, alert_type?: string | null, content_id?: string | null, entity_name?: string | null, entity_type?: string | null, first_seen?: number | null, last_seen?: number | null, severity?: number | null, tenant?: string | null, tenant_detection?: string | null, tenant_entity?: string | null, total_detections?: number | null, is_custom_severity?: boolean | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null } | null> | null } | null };

export type GetEntitySuppressionConfigurationQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type GetEntitySuppressionConfigurationQuery = { __typename?: 'Query', getEntitySuppressionConfiguration?: { __typename?: 'EntitySuppressionConfiguration', reason_for_suppression?: string | null, file_name?: string | null, file_content?: string | null, file_updated_at?: number | null, file_updated_by?: string | null, tenant?: string | null, fields_to_suppress?: Array<AlertField | null> | null } | null };

export type CreateEntitySuppressionConfigurationMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  create_config?: InputMaybe<CreateEntitySuppressionConfigurationInput>;
}>;


export type CreateEntitySuppressionConfigurationMutation = { __typename?: 'Mutation', createEntitySuppressionConfiguration?: { __typename?: 'EntitySuppressionConfiguration', reason_for_suppression?: string | null, file_name?: string | null, file_content?: string | null, file_updated_at?: number | null, file_updated_by?: string | null, tenant?: string | null, fields_to_suppress?: Array<AlertField | null> | null } | null };

export type UpdateEntitySuppressionConfigurationMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  update_config?: InputMaybe<UpdateEntitySuppressionConfigurationInput>;
}>;


export type UpdateEntitySuppressionConfigurationMutation = { __typename?: 'Mutation', updateEntitySuppressionConfiguration?: { __typename?: 'EntitySuppressionConfiguration', reason_for_suppression?: string | null, file_name?: string | null, file_content?: string | null, file_updated_at?: number | null, file_updated_by?: string | null, tenant?: string | null, fields_to_suppress?: Array<AlertField | null> | null } | null };

export type DeleteEntitySuppressionConfigurationMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type DeleteEntitySuppressionConfigurationMutation = { __typename?: 'Mutation', deleteEntitySuppressionConfiguration?: { __typename?: 'EntitySuppressionConfiguration', reason_for_suppression?: string | null, file_name?: string | null, file_content?: string | null, file_updated_at?: number | null, file_updated_by?: string | null, tenant?: string | null, fields_to_suppress?: Array<AlertField | null> | null } | null };

export type GetFeatureMetadataQueryVariables = Exact<{
  input: FeatureMetaDataGetInput;
}>;


export type GetFeatureMetadataQuery = { __typename?: 'Query', getFeatureMetadata?: Array<{ __typename?: 'FeatureMetadata', category?: string | null, data_type?: string | null, definition?: string | null, description?: string | null, display_name?: string | null, name?: string | null, pipeline?: string | null } | null> | null };

export type GetFirstMostSevereAndLatestDetectionsByEntityNameQueryVariables = Exact<{
  entity_name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFirstMostSevereAndLatestDetectionsByEntityNameQuery = { __typename?: 'Query', getFirstMostSevereAndLatestDetectionsByEntityName?: { __typename?: 'DetectionsByEntityNameResult', entity_name: string, tenant?: string | null, total_detections?: number | null, most_severe_alert_categories?: Array<string | null> | null, number_of_most_severe_alert_categories?: number | null, detection_counts_by_severity_level?: { __typename?: 'DetectionCountsBySeverityLevel', low?: number | null, medium?: number | null, high?: number | null } | null, detection_counts_by_mitre_tactics?: Array<{ __typename?: 'DetectionCountsByMitreTactic', mitre_tactic: string, detection_count: number } | null> | null, detection_counts_by_status?: { __typename?: 'DetectionCountsByStatus', open?: number | null, closed?: number | null } | null, first_detection?: { __typename?: 'Detection', earliest_start_timestamp?: number | null, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, content_id?: string | null }, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null } } | null, most_recent_detection?: { __typename?: 'Detection', latest_start_timestamp?: number | null, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, content_id?: string | null }, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null } } | null, most_severe_detection?: { __typename?: 'Detection', latest_start_timestamp?: number | null, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, content_id?: string | null }, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null } } | null } | null };

export type GetModelSummariesQueryVariables = Exact<{
  model_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetModelSummariesQuery = { __typename?: 'Query', getModelSummaries?: Array<{ __typename?: 'ModelSummary', del_features?: string | null, model_description?: string | null, model_id?: string | null, model_trained_by?: string | null, model_trained_on?: string | null, satisfactory_auc?: number | null, satisfactory_tpr?: number | null, successful_training?: boolean | null, tag_ids?: Array<string | null> | null, training_set_size?: number | null, used_features?: Array<string | null> | null, algorithm_params?: { __typename?: 'AlgorithmParameters', algorithm?: string | null, compute_norm_values?: boolean | null, data_strategy?: string | null, eliminate_outliers?: boolean | null, label_threshold?: number | null, learners?: number | null, remove_correlated?: number | null, remove_sparse?: boolean | null, tune_training_set?: boolean | null } | null, feature_details?: { __typename?: 'ModelFeatureSummary', feature_count?: number | null, model_id?: string | null, feature_histograms?: Array<{ __typename?: 'FeatureHistogramData', name?: string | null, bins?: Array<{ __typename?: 'FeatureHistogramBin', count?: number | null, cut?: number | null } | null> | null } | null> | null, feature_minmax?: Array<{ __typename?: 'FeatureMinMaxData', max?: number | null, mean?: number | null, min?: number | null, name?: string | null, pct_10?: number | null, pct_25?: number | null, pct_5?: number | null, pct_50?: number | null, pct_75?: number | null, pct_90?: number | null, pct_95?: number | null, std?: number | null } | null> | null } | null, feature_importance?: Array<{ __typename?: 'FeatureImportance', importance?: number | null, name?: string | null } | null> | null, labels?: { __typename?: 'ModelLabels', tag?: Array<{ __typename?: 'ModelLabelsTagCount', count?: number | null, name?: string | null } | null> | null, used_global_labels?: { __typename?: 'ModelLabelCounts', normal?: number | null, unknown?: number | null } | null, used_local_labels?: { __typename?: 'ModelLabelCounts', normal?: number | null, unknown?: number | null } | null } | null, model_parameters?: { __typename?: 'ModelParameters', mode?: string | null } | null, performance_curves?: { __typename?: 'ModelPerformanceCurves', pr_curve_thresholds?: Array<number | null> | null, pr_curve_x?: Array<number | null> | null, pr_curve_y?: Array<number | null> | null, roc_curve_thresholds?: Array<number | null> | null, roc_curve_x?: Array<number | null> | null, roc_curve_y?: Array<number | null> | null } | null, preprocessing_filters?: { __typename?: 'PreprocessingFilters', predict?: Array<{ __typename?: 'PreprocessingFiltersPredict', filter?: string | null } | null> | null, train?: Array<{ __typename?: 'PreprocessingFiltersTrain', filter?: string | null, tag_id?: string | null } | null> | null } | null, performance_stats?: { __typename?: 'ModelPerformanceStats', auc?: number | null, cost?: number | null, estimated_daily_alerts?: number | null, pdr?: number | null, pr_auc?: number | null } | null, training_set_dates?: { __typename?: 'TrainingSetDates', end_date?: string | null, start_date?: string | null } | null } | null> | null };

export type GetTopDetectionEntitiesInsightsPaginatedQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
  include_ai_insights?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetTopDetectionEntitiesInsightsPaginatedQuery = { __typename?: 'Query', getTopDetectionEntitiesInsightsPaginated?: { __typename?: 'PaginatedDetectionSummaryInsights', offset?: number | null, size?: number | null, total_items?: number | null, summary_insights?: Array<{ __typename?: 'DetectionSummaryInsights', total_detections?: number | null, entity_id?: string | null, entity_name?: string | null, entity_category?: string | null, entity_type?: string | null, max_severity?: number | null, tenant?: string | null, tenant_entity?: string | null, comment_count?: number | null, entity_locality?: EntityLocality | null, most_severe_alert_category?: string | null, detection_counts_by_mitre_tactics?: Array<{ __typename?: 'DetectionCountsByMitreTactic', mitre_tactic: string, detection_count: number } | null> | null, detection_counts_by_status?: { __typename?: 'DetectionCountsByStatus', open?: number | null, closed?: number | null } | null, detection_counts_by_severity_level?: { __typename?: 'DetectionCountsBySeverityLevel', low?: number | null, medium?: number | null, high?: number | null } | null, ai_insights?: { __typename?: 'AIInsights', ai_insight_verdict?: AiInsightVerdict | null, short_description?: string | null, ai_insight_report_id?: string | null, created_timestamp?: number | null } | null } | null> | null } | null };

export type GetTopDetectionEntitiesPaginatedQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetTopDetectionEntitiesPaginatedQuery = { __typename?: 'Query', getTopDetectionEntitiesPaginated?: { __typename?: 'PaginatedDetectionSummaries', offset?: number | null, size?: number | null, total_items?: number | null, summaries?: Array<{ __typename?: 'DetectionSummary', detection_count?: number | null, total_detections?: number | null, entity_id?: string | null, entity_name?: string | null, entity_category?: string | null, entity_type?: string | null, severity?: number | null, tenant?: string | null, tenant_entity?: string | null, first_seen?: number | null, last_seen?: number | null, is_custom_severity?: boolean | null, alert_name?: string | null, alert_type?: string | null, content_id?: string | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null } | null> | null } | null };

export type GetTopDetectionsByDetectionGroupsPerEntityFullQueryVariables = Exact<{
  tenant_entity: Scalars['String']['input'];
  group_by: DetectionGroups;
  tenant?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Float']['input'];
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  start: Scalars['Float']['input'];
}>;


export type GetTopDetectionsByDetectionGroupsPerEntityFullQuery = { __typename?: 'Query', getTopDetectionsByDetectionGroupsPerEntity?: { __typename?: 'DetectionsByDetectionGroupsPerEntity', tenant_entity?: string | null, tenant?: string | null, end?: number | null, size?: number | null, start?: number | null, group_by: DetectionGroups, data?: Array<{ __typename?: 'DetectionsByDetectionGroupPerEntity', group_key: string, detections_count?: number | null, detections?: Array<{ __typename?: 'Detection', tenant: string, detection_id: string, created_timestamp: number, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, mitre_tactics?: Array<string | null> | null, mitre_techniques?: Array<string | null> | null, total_alert_count: number, logscale_query?: string | null, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null }, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } } | null> | null } | null> | null } | null };

export type GetTopDetectionsRawPaginatedQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetTopDetectionsRawPaginatedQuery = { __typename?: 'Query', getTopDetectionsRawPaginated?: { __typename?: 'PaginatedDetectionSummaries', total_items?: number | null, offset?: number | null, size?: number | null, summaries?: Array<{ __typename?: 'DetectionSummary', alert_name?: string | null, alert_type?: string | null, content_id?: string | null, detection_count?: number | null, entity_count?: number | null, entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, first_seen?: number | null, last_seen?: number | null, severity?: number | null, tenant?: string | null, tenant_detection?: string | null, tenant_entity?: string | null, total_detections?: number | null, is_custom_severity?: boolean | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null };

export type GetEntityDetectionTimelinePaginatedLazyQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  must_conds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['String']['input']>;
  tenant_entity?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetEntityDetectionTimelinePaginatedLazyQuery = { __typename?: 'Query', getEntityDetectionTimelinePaginated?: { __typename?: 'EntityDetectionTimeline', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, is_truncated?: boolean | null, offset?: number | null, severity?: number | null, size?: number | null, tenant?: string | null, tenant_entity?: string | null, total_detections?: number | null, total_grouped_entities?: number | null, total_items?: number | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null, data?: Array<{ __typename?: 'EntityDetectionTimelineItem', alert_name?: string | null, alert_type?: string | null, content_id?: string | null, entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, first_seen?: number | null, last_seen?: number | null, severity?: number | null, tenant?: string | null, tenant_detection?: string | null, tenant_entity?: string | null, total_detections?: number | null, is_custom_severity?: boolean | null, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null } | null> | null } | null };

export type QueryAlertMetadataExcludedEntitiesPaginatedQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertMetadataExcludedEntitiesPaginatedQuery = { __typename?: 'Query', queryAlertMetadataExcludedEntitiesPaginated?: { __typename?: 'PaginatedExcludedEntities', offset?: number | null, size?: number | null, total_items?: number | null, excluded_entities?: Array<{ __typename?: 'ExcludedEntity', _score?: number | null, content_id?: string | null, entity_id?: string | null, entity_ip?: string | null, entity_ip_range?: string | null, entity_name?: string | null, entity_type?: AlertEntityType | null, tenant?: string | null, created_by?: string | null, created_by_alias?: string | null, created_timestamp?: number | null } | null> | null } | null };

export type QueryAlertMetadataPaginatedQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertMetadataPaginatedQuery = { __typename?: 'Query', queryAlertMetadataPaginated?: { __typename?: 'PaginatedAlertMetadata', offset?: number | null, size?: number | null, total_items?: number | null, metadata?: Array<{ __typename?: 'AlertMetadata', _score?: number | null, title?: string | null, severity?: number | null, active?: boolean | null, content_id?: string | null, tenant_alert?: string | null, severity_info?: { __typename?: 'SeverityInfo', custom_severity?: number | null, custom_severity_enabled?: boolean | null, default_severity?: number | null, last_updated_by_user_alias?: string | null, last_updated_by_username?: string | null, last_updated_timestamp?: number | null } | null, logsource?: { __typename?: 'MetadataLogSource', category?: string | null } | null, custom_search_rule?: { __typename?: 'CustomSearchRuleAlertMetadata', query_string?: string | null, query_filter?: string | null, throttle_time?: string | null, time_interval?: string | null } | null } | null> | null } | null };

export type QueryAlertsMlPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsMlPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert', average_technique_score_map?: any | null, description?: string | null, alert_id: string, event_ids?: Array<string | null> | null, false_positive?: boolean | null, mode?: string | null, pipeline?: string | null, score?: number | null, severity?: number | null, status?: string | null, tag_id?: string | null, tenant: string, user_tag?: any | null, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_alert_entity?: string | null, tenant_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', end?: number | null, observed?: number | null, start?: number | null, ttl?: number | null } | null, models?: Array<{ __typename?: 'MLModels', model_alias?: Array<string | null> | null, model_name?: string | null, model_score?: number | null, predicted_tag_id?: string | null, features?: Array<{ __typename?: 'MLFeatures', actual?: number | null, contribution?: number | null, difference?: number | null, feature_name?: string | null } | null> | null } | null> | null, related_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null> | null, whitelisted_info?: Array<{ __typename?: 'MLWhiteListEntry', entity_name?: string | null, whitelisted?: boolean | null, whitelisted_for?: string | null } | null> | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsNoticePaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsNoticePaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert', alert_id: string, msg?: string | null, uid?: string | null, tenant: string, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_entity?: string | null, tenant_alert_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsNoticeSummaryPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  log_search_client_session_id: Scalars['String']['input'];
}>;


export type QueryAlertsNoticeSummaryPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert', session_summary?: { __typename?: 'AlertSessionSummary', ioc?: Array<string | null> | null, alert_summary?: Array<string | null> | null, alert_beacons?: Array<string | null> | null, unusual_findings?: Array<string | null> | null, attack_tactics?: Array<string | null> | null } | null } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsSearchBasedPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsSearchBasedPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert', alert_id: string, event_ids?: Array<string | null> | null, false_positive?: boolean | null, score?: number | null, severity?: number | null, tenant: string, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_alert_entity?: string | null, tenant_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', end?: number | null, observed?: number | null, start?: number | null, ttl?: number | null } | null, related_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null> | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsSuricataPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsSuricataPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert', alert_id: string, community_id?: string | null, destination_ip?: string | null, signature_id?: string | null, suri_id?: string | null, uid?: string | null, tenant: string, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_entity?: string | null, tenant_alert_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsSuricataPayloadPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  log_search_client_session_id: Scalars['String']['input'];
}>;


export type QueryAlertsSuricataPayloadPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert', uid?: string | null, payload?: string | null, payload_summary?: string | null, session_summary?: { __typename?: 'AlertSessionSummary', ioc?: Array<string | null> | null, alert_summary?: Array<string | null> | null, alert_beacons?: Array<string | null> | null, unusual_findings?: Array<string | null> | null, attack_tactics?: Array<string | null> | null } | null } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryAlertsSuricataPayloadLLmDisabledPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsSuricataPayloadLLmDisabledPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert', uid?: string | null, payload?: string | null } | { __typename?: 'YaraAlert' } | null> | null } | null };

export type QueryDetectionIdsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryDetectionIdsQuery = { __typename?: 'Query', queryDetectionsPaginated?: { __typename?: 'PaginatedDetections', total_items?: number | null, detections?: Array<{ __typename?: 'Detection', detection_id: string, tenant: string } | null> | null } | null };

export type QueryDetectionsPaginatedQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  dest_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
  source_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
}>;


export type QueryDetectionsPaginatedQuery = { __typename?: 'Query', queryDetectionsPaginated?: { __typename?: 'PaginatedDetections', offset?: number | null, size?: number | null, total_items?: number | null, detections?: Array<{ __typename?: 'Detection', created_timestamp: number, detection_id: string, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, tenant: string, total_alert_count: number, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null }, assignment_info?: { __typename?: 'DetectionAssignmentInfo', assigned_at?: number | null, assigned_to_username?: string | null, assigned_to_user_alias?: string | null } | null, detection_keys?: { __typename?: 'DetectionKeys', tenant_detection?: string | null, tenant_detection_entity?: string | null, tenant_entity?: string | null } | null, detection_timestamp: { __typename?: 'DetectionTimestamp', end?: number | null, start: number }, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null }, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null, update_info?: { __typename?: 'DetectionUpdateInfo', last_updated_by?: string | null, last_updated_timestamp?: number | null } | null, escalation_data?: { __typename?: 'DetectionEscalationData', escalation_status?: boolean | null, escalated_by_user_alias?: string | null, escalated_timestamp?: number | null, escalation_service_name?: EscalationServiceNameEnum | null } | null, paginated_destination_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null, paginated_source_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null } | null> | null } | null };

export type QueryDetectionsPaginatedQueryQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  dest_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
  source_paginated_entity_input?: InputMaybe<PaginatedEntityInput>;
}>;


export type QueryDetectionsPaginatedQueryQuery = { __typename?: 'Query', queryDetectionsPaginated?: { __typename?: 'PaginatedDetections', offset?: number | null, size?: number | null, total_items?: number | null, detections?: Array<{ __typename?: 'Detection', created_timestamp: number, detection_id: string, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, tenant: string, total_alert_count: number, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null }, assignment_info?: { __typename?: 'DetectionAssignmentInfo', assigned_at?: number | null, assigned_to_username?: string | null, assigned_to_user_alias?: string | null } | null, detection_timestamp: { __typename?: 'DetectionTimestamp', end?: number | null, start: number }, rank: { __typename?: 'DetectionRank', severity: number, is_custom_severity?: boolean | null }, tenant_info?: { __typename?: 'AlertAndDetectionTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null, update_info?: { __typename?: 'DetectionUpdateInfo', last_updated_by?: string | null, last_updated_timestamp?: number | null } | null, escalation_data?: { __typename?: 'DetectionEscalationData', escalation_status?: boolean | null, escalated_by_user_alias?: string | null, escalated_timestamp?: number | null, escalation_service_name?: EscalationServiceNameEnum | null } | null, paginated_destination_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null, paginated_source_entities?: { __typename?: 'PaginatedAlertEntities', offset?: number | null, size?: number | null, total_items?: number | null, alert_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, sort?: Array<{ __typename?: 'SortParameter', sort_by: string, sort_dir: string } | null> | null } | null } | null> | null } | null };

export type QueryDetectionsPaginatedTotalItemsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryDetectionsPaginatedTotalItemsQuery = { __typename?: 'Query', queryDetectionsPaginated?: { __typename?: 'PaginatedDetections', total_items?: number | null } | null };

export type RemoveExcludedEntitiesFromAlertMetadataMutationVariables = Exact<{
  items: Array<InputMaybe<ExcludedEntityInput>> | InputMaybe<ExcludedEntityInput>;
}>;


export type RemoveExcludedEntitiesFromAlertMetadataMutation = { __typename?: 'Mutation', removeExcludedEntitiesFromAlertMetadata?: { __typename?: 'PaginatedExcludedEntities', offset?: number | null, size?: number | null, total_items?: number | null, excluded_entities?: Array<{ __typename?: 'ExcludedEntity', _score?: number | null, content_id?: string | null, entity_id?: string | null, entity_ip?: string | null, entity_ip_range?: string | null, entity_name?: string | null, entity_type?: AlertEntityType | null, tenant?: string | null, created_by?: string | null, created_by_alias?: string | null, created_timestamp?: number | null } | null> | null } | null };

export type SetAlertActiveStatusMutationVariables = Exact<{
  items: Array<InputMaybe<AlertMetadataInput>> | InputMaybe<AlertMetadataInput>;
}>;


export type SetAlertActiveStatusMutation = { __typename?: 'Mutation', setAlertActiveStatus?: { __typename?: 'PaginatedAlertMetadata', offset?: number | null, size?: number | null, total_items?: number | null, metadata?: Array<{ __typename?: 'AlertMetadata', _score?: number | null, title?: string | null, severity?: number | null, active?: boolean | null, content_id?: string | null, tenant_alert?: string | null, logsource?: { __typename?: 'MetadataLogSource', category?: string | null } | null } | null> | null } | null };

export type SetAlertStatusBySearchTermMutationVariables = Exact<{
  items: Array<InputMaybe<SetAlertStatusBySearchTermInput>> | InputMaybe<SetAlertStatusBySearchTermInput>;
}>;


export type SetAlertStatusBySearchTermMutation = { __typename?: 'Mutation', setAlertStatusBySearchTerm: Array<{ __typename?: 'SetAlertStatusBySearchTermResult', updated_record_count: number, tenant: string } | null> };

export type SetSeverityOnAlertsMutationVariables = Exact<{
  items: Array<SetSeverityOnAlertsInput> | SetSeverityOnAlertsInput;
}>;


export type SetSeverityOnAlertsMutation = { __typename?: 'Mutation', setSeverityOnAlerts?: { __typename?: 'PaginatedAlertMetadata', offset?: number | null, size?: number | null, total_items?: number | null, metadata?: Array<{ __typename?: 'AlertMetadata', _score?: number | null, title?: string | null, severity?: number | null, active?: boolean | null, content_id?: string | null, tenant_alert?: string | null, logsource?: { __typename?: 'MetadataLogSource', category?: string | null } | null } | null> | null } | null };

export type SetStatusOnDetectionsMutationVariables = Exact<{
  items: Array<SetStatusOnDetectionsInput> | SetStatusOnDetectionsInput;
}>;


export type SetStatusOnDetectionsMutation = { __typename?: 'Mutation', setStatusOnDetections?: { __typename?: 'PaginatedDetections', offset?: number | null, size?: number | null, total_items?: number | null, detections?: Array<{ __typename?: 'Detection', created_timestamp: number, detection_id: string, detection_status: DetectionStatus, earliest_start_timestamp?: number | null, latest_start_timestamp?: number | null, total_alert_count: number, alert_entity: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null }, alert_info: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null }, assignment_info?: { __typename?: 'DetectionAssignmentInfo', assigned_to_username?: string | null, assigned_at?: number | null } | null, detection_timestamp: { __typename?: 'DetectionTimestamp', end?: number | null, start: number }, rank: { __typename?: 'DetectionRank', severity: number }, update_info?: { __typename?: 'DetectionUpdateInfo', last_updated_by?: string | null, last_updated_timestamp?: number | null } | null, escalation_data?: { __typename?: 'DetectionEscalationData', escalation_status?: boolean | null, escalated_by_user_alias?: string | null, escalated_timestamp?: number | null, escalation_service_name?: EscalationServiceNameEnum | null } | null } | null> | null } | null };

export type SetAlertAndDetectionTenantConfigsMutationVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetAlertAndDetectionTenantConfigsMutation = { __typename?: 'Mutation', setAlertAndDetectionTenantConfigs?: { __typename?: 'ConfigResponse', tenant?: string | null, category?: string | null, configs?: Array<{ __typename?: 'ConfigInfo', config_key?: string | null, config_value?: boolean | null } | null> | null } | null };

export type QueryAlertsYaraPaginatedQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type QueryAlertsYaraPaginatedQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename: 'AnomalyAlert' } | { __typename: 'CustomSearchRuleAlert' } | { __typename: 'GenericAlert' } | { __typename: 'IntelAlert' } | { __typename: 'MlAlert' } | { __typename: 'NoticeAlert' } | { __typename: 'SuricataAlert' } | { __typename: 'YaraAlert', alert_id: string, path?: string | null, system_name?: string | null, uid?: string | null, orig_h?: string | null, orig_p?: number | null, resp_h?: string | null, resp_p?: number | null, fuid?: string | null, file_name?: string | null, source?: string | null, mime_type?: string | null, md5?: string | null, sha1?: string | null, sha256?: string | null, source_ip?: string | null, destination_ip?: string | null, tenant: string, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_keys?: { __typename?: 'AlertKeys', tenant_alert?: string | null, tenant_entity?: string | null, tenant_alert_entity?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, source_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null, destination_entities?: Array<{ __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null, entity_category?: EntityCategory | null } | null> | null } | null> | null } | null };

export type QueryAlertsYaraSummaryQueryVariables = Exact<{
  query: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
  log_search_client_session_id: Scalars['String']['input'];
}>;


export type QueryAlertsYaraSummaryQuery = { __typename?: 'Query', queryAlertsPaginated?: { __typename?: 'PaginatedAlerts', offset?: number | null, size?: number | null, total_items?: number | null, alerts?: Array<{ __typename?: 'AnomalyAlert' } | { __typename?: 'CustomSearchRuleAlert' } | { __typename?: 'GenericAlert' } | { __typename?: 'IntelAlert' } | { __typename?: 'MlAlert' } | { __typename?: 'NoticeAlert' } | { __typename?: 'SuricataAlert' } | { __typename?: 'YaraAlert', alert_id: string, path?: string | null, system_name?: string | null, uid?: string | null, orig_h?: string | null, orig_p?: number | null, resp_h?: string | null, resp_p?: number | null, fuid?: string | null, file_name?: string | null, source?: string | null, mime_type?: string | null, md5?: string | null, sha1?: string | null, sha256?: string | null, source_ip?: string | null, destination_ip?: string | null, alert_info?: { __typename?: 'AlertInfo', alert_name?: string | null, alert_type?: string | null, content_id?: string | null } | null, alert_entity?: { __typename?: 'AlertEntity', entity_id?: string | null, entity_name?: string | null, entity_type?: string | null } | null, alert_timestamp?: { __typename?: 'AlertTimestamp', observed?: number | null } | null, session_summary?: { __typename?: 'AlertSessionSummary', ioc?: Array<string | null> | null, alert_summary?: Array<string | null> | null, alert_beacons?: Array<string | null> | null, unusual_findings?: Array<string | null> | null, attack_tactics?: Array<string | null> | null } | null } | null> | null } | null };

export type GetYaraAlertMetadataQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  content_id: Scalars['String']['input'];
}>;


export type GetYaraAlertMetadataQuery = { __typename?: 'Query', getAlertMetadata?: { __typename?: 'PaginatedAlertMetadata', metadata?: Array<{ __typename?: 'AlertMetadata', id?: string | null, author?: string | null, date?: string | null, title?: string | null, match_meta?: Array<string | null> | null } | null> | null } | null };

export type DeleteEdrConfigurationMutationVariables = Exact<{
  provider_name: EdrConfigurationType;
}>;


export type DeleteEdrConfigurationMutation = { __typename?: 'Mutation', deleteEDRConfiguration?: { __typename?: 'CrowdStrikeConfiguration', provider_name?: EdrConfigurationType | null, polling_seconds?: number | null, enabled?: boolean | null, client_id?: string | null, client_secret?: string | null, base_url?: string | null } | { __typename?: 'MicrosoftDefenderConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null };

export type GetEdrConfigurationQueryVariables = Exact<{
  provider_name: EdrConfigurationType;
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEdrConfigurationQuery = { __typename?: 'Query', getEDRConfiguration?: { __typename?: 'CrowdStrikeConfiguration', client_id?: string | null, client_secret?: string | null, base_url?: string | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftDefenderConfiguration', app_id?: string | null, app_secret?: string | null, defender_tenant_id?: string | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', entra_tenant_id?: string | null, entra_client_id?: string | null, entra_client_secret?: string | null, identity_enrichment_enabled?: boolean | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', access_key?: string | null, bucket?: string | null, prefix?: string | null, region?: string | null, secret_key?: string | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null };

export type GetEdrConfigurationPublicQueryVariables = Exact<{
  provider_name: EdrConfigurationType;
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEdrConfigurationPublicQuery = { __typename?: 'Query', getEDRConfiguration?: { __typename?: 'CrowdStrikeConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftDefenderConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null };

export type GetEdrConfigurationsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetEdrConfigurationsQuery = { __typename?: 'Query', getEDRConfigurations?: { __typename?: 'PaginatedEDRConfigurations', edr_configurations?: Array<{ __typename?: 'CrowdStrikeConfiguration', base_url?: string | null, client_id?: string | null, client_secret?: string | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftDefenderConfiguration', app_id?: string | null, app_secret?: string | null, defender_tenant_id?: string | null, edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null> | null } | null };

export type GetEdrConfigurationsPublicQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetEdrConfigurationsPublicQuery = { __typename?: 'Query', getEDRConfigurations?: { __typename?: 'PaginatedEDRConfigurations', edr_configurations?: Array<{ __typename?: 'CrowdStrikeConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftDefenderConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null> | null } | null };

export type StoreEdrConfigurationMutationVariables = Exact<{
  provider_name: EdrConfigurationType;
  config: EdrConfigurationInput;
}>;


export type StoreEdrConfigurationMutation = { __typename?: 'Mutation', storeEDRConfiguration?: { __typename?: 'CrowdStrikeConfiguration', client_id?: string | null, client_secret?: string | null, base_url?: string | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftDefenderConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null };

export type VerifyEdrConfigurationQueryVariables = Exact<{
  provider_name: EdrConfigurationType;
  config: EdrConfigurationInput;
}>;


export type VerifyEdrConfigurationQuery = { __typename?: 'Query', verifyEDRConfiguration?: { __typename?: 'VerifiedEDRConfiguration', verified?: boolean | null } | null };

export type GetEdrConfigurationLazyQueryVariables = Exact<{
  provider_name: EdrConfigurationType;
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEdrConfigurationLazyQuery = { __typename?: 'Query', getEDRConfiguration?: { __typename?: 'CrowdStrikeConfiguration', provider_name?: EdrConfigurationType | null, polling_seconds?: number | null, enabled?: boolean | null, edr_action_enabled?: boolean | null } | { __typename?: 'MicrosoftDefenderConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'MicrosoftEntraIDConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | { __typename?: 'PaloAltoNetworksConfiguration', edr_action_enabled?: boolean | null, provider_name?: EdrConfigurationType | null, enabled?: boolean | null, polling_seconds?: number | null } | null };

export type GetCommentsByEntityNamePaginatedQueryVariables = Exact<{
  entity_name: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommentSortParameterInput>;
  start_ts: Scalars['Float']['input'];
  end_ts: Scalars['Float']['input'];
}>;


export type GetCommentsByEntityNamePaginatedQuery = { __typename?: 'Query', getCommentsByEntityNamePaginated?: { __typename?: 'PaginatedComments', total_count?: number | null, offset?: number | null, size?: number | null, comments?: Array<{ __typename?: 'Comment', comment_id?: string | null, comment?: string | null, created_at?: number | null, author_alias?: string | null, severity?: number | null, alert_name?: string | null, parent?: { __typename?: 'CommentParent', parent_object_id?: string | null, parent_object_type?: CommentParentType | null } | null } | null> | null } | null };

export type GetConsolidatedEntityTriageReportsQueryVariables = Exact<{
  tenantReportIdList?: InputMaybe<Array<TenantReportIdInput> | TenantReportIdInput>;
  tenantEntityInput?: InputMaybe<TenantEntityIdInput>;
}>;


export type GetConsolidatedEntityTriageReportsQuery = { __typename?: 'Query', getConsolidatedEntityTriageReports?: Array<{ __typename?: 'ConsolidatedEntityTriageReport', report_id: string, tenant: string, entity_id: string, investigation_id: string, investigation_start_timestamp?: number | null, investigation_end_timestamp?: number | null, created_at?: number | null, entity_info?: { __typename?: 'EntityInfo', summary?: string | null } | null, analysis_summary?: { __typename?: 'AnalysisSummary', verdict?: Verdict | null, description?: string | null, details?: Array<string | null> | null } | null, detections_info?: { __typename?: 'DetectionsInfo', description?: string | null } | null, playbook?: { __typename?: 'Playbook', assessment_summary?: Array<{ __typename?: 'AssessmentStep', step_name?: string | null, summary?: string | null } | null> | null } | null, key_findings_info?: { __typename?: 'KeyFindingsInfo', summary?: string | null, key_findings?: Array<{ __typename?: 'KeyFinding', title?: string | null, description?: string | null, justification?: string | null, logs_query?: string | null, evidences?: Array<{ __typename?: 'Evidence', agent?: string | null, source?: EvidenceSource | null, detection_id?: string | null, entity_triage_id?: string | null, tool_name?: string | null } | null> | null } | null> | null } | null, recommended_actions_info?: { __typename?: 'RecommendedActionsInfo', to_isolate_entity?: boolean | null, recommended_actions?: Array<string | null> | null } | null } | null> | null };

export type GetEdrPayloadQueryVariables = Exact<{
  alert_entity_info?: InputMaybe<AlertEntityInfoInput>;
  as_of?: InputMaybe<Scalars['Float']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEdrPayloadQuery = { __typename?: 'Query', getEdrPayload?: { __typename?: 'EdrPayload', ad_domain_name?: string | null, ad_organizational_unit_name?: string | null, cloud_account_id?: string | null, cloud_instance_id?: string | null, cloud_provider?: string | null, data_source?: string | null, device_id?: string | null, entity_id?: string | null, entity_type?: EntityDataStoreEntityType | null, expire_at?: number | null, external_ips?: Array<string | null> | null, host_names?: Array<string | null> | null, last_updated_timestamp?: number | null, mac_addresses?: Array<string | null> | null, obsts?: number | null, os?: string | null, platform?: string | null, platform_type?: string | null, sensor_version?: string | null, tenant?: string | null, nic_history?: { __typename?: 'PaginatedNICHistory', as_of?: number | null, max_results?: number | null, offset?: number | null, size?: number | null, total_items?: number | null, use_cache?: boolean | null, nic_histories?: Array<{ __typename?: 'NICHistory', data_source?: string | null, ip_address?: string | null, mac_address?: string | null, obsts?: number | null } | null> | null } | null, user_history?: { __typename?: 'PaginatedUserHistory', as_of?: number | null, max_results?: number | null, offset?: number | null, size?: number | null, total_items?: number | null, use_cache?: boolean | null, user_histories?: Array<{ __typename?: 'UserHistory', data_source?: string | null, obsts?: number | null, username?: string | null } | null> | null } | null } | null };

export type GetEdrEndpointDevicesQueryVariables = Exact<{
  edr_endpoint_device_inputs: Array<EdrEndpointDeviceInput> | EdrEndpointDeviceInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEdrEndpointDevicesQuery = { __typename?: 'Query', getEdrEndpointDevices?: { __typename: 'PaginatedEdrEndpointDevices', offset?: number | null, size?: number | null, total_items?: number | null, edr_endpoint_devices?: Array<{ __typename: 'CrowdStrikeEndpointDevice', device_id?: string | null, tenant?: string | null, entity_type?: EntityDataStoreEntityType | null, entity_id?: string | null, data_source?: EdrConfigurationType | null, obsts?: number | null, expire_at?: number | null, last_updated_timestamp?: number | null, host_info?: { __typename?: 'CrowdStrikeHostInfo', platform?: string | null, platform_type?: string | null, os?: string | null, sensor_version?: string | null, cloud_account_id?: string | null, cloud_instance_id?: string | null, cloud_provider?: string | null, ad_domain_name?: string | null, ad_organizational_unit_name?: string | null, mac_address?: string | null, external_ip?: string | null, host_name?: string | null, local_ip?: string | null } | null, nic_history?: { __typename?: 'PaginatedNICHistory', as_of?: number | null, offset?: number | null, size?: number | null, max_results?: number | null, use_cache?: boolean | null, total_items?: number | null, nic_histories?: Array<{ __typename?: 'NICHistory', ip_address?: string | null, mac_address?: string | null, obsts?: number | null } | null> | null } | null, user_history?: { __typename?: 'PaginatedUserHistory', as_of?: number | null, offset?: number | null, size?: number | null, max_results?: number | null, use_cache?: boolean | null, total_items?: number | null, user_histories?: Array<{ __typename?: 'UserHistory', username?: string | null, obsts?: number | null } | null> | null } | null } | { __typename: 'MicrosoftDefenderEndpointDevice', id?: string | null, tenant?: string | null, entity_type?: EntityDataStoreEntityType | null, entity_id?: string | null, data_source?: EdrConfigurationType | null, obsts?: number | null, expire_at?: number | null, last_updated_timestamp?: number | null, machine?: { __typename?: 'MicrosoftDefenderMachine', mergedIntoMachineId?: string | null, isPotentialDuplication?: boolean | null, isExcluded?: boolean | null, exclusionReason?: string | null, computerDnsName?: string | null, firstSeen?: number | null, lastSeen?: number | null, osPlatform?: string | null, osVersion?: string | null, osProcessor?: string | null, version?: string | null, lastIpAddress?: string | null, lastExternalIpAddress?: string | null, agentVersion?: string | null, osBuild?: number | null, healthStatus?: string | null, deviceValue?: string | null, rbacGroupId?: number | null, rbacGroupName?: string | null, riskScore?: string | null, exposureLevel?: string | null, isAadJoined?: boolean | null, aadDeviceId?: string | null, machineTags?: Array<string | null> | null, defenderAvStatus?: string | null, onboardingStatus?: string | null, osArchitecture?: string | null, managedBy?: string | null, managedByStatus?: string | null, ipAddresses?: Array<{ __typename?: 'MicrosoftDefenderIpAddresses', ipAddress?: string | null, macAddress?: string | null, type?: string | null, operationalStatus?: string | null } | null> | null, vmMetadata?: { __typename?: 'MicrosoftDefenderVmMetadata', vmId?: string | null, cloudProvider?: string | null, resourceId?: string | null, subscriptionId?: string | null } | null } | null, machine_actions?: Array<{ __typename?: 'MicrosoftDefenderMachineActions', id?: string | null, type?: string | null, status?: string | null, requestor?: string | null, requestorComment?: string | null, creationDateTimeUtc?: number | null, lastUpdateDateTimeUtc?: number | null } | null> | null } | null> | null } | null };

export type GetEntityEdrStatusQueryVariables = Exact<{
  entity_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEntityEdrStatusQuery = { __typename?: 'Query', getEntityEdrStatus?: { __typename?: 'EntityEdrStatusWithTimestamp', tenant?: string | null, entity_edr_status?: EntityEdrStatus | null, updated_timestamp?: number | null } | null };

export type GetEntityDetectionTimelineSummaryQueryVariables = Exact<{
  entity_name?: InputMaybe<Scalars['String']['input']>;
  detection_tenant?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  top_n?: InputMaybe<Scalars['Int']['input']>;
  alert_name_filter?: InputMaybe<Array<InputMaybe<AlertNameFilterInput>> | InputMaybe<AlertNameFilterInput>>;
  severity_filter?: InputMaybe<Array<InputMaybe<DetectionAlertSummarySeverities>> | InputMaybe<DetectionAlertSummarySeverities>>;
}>;


export type GetEntityDetectionTimelineSummaryQuery = { __typename?: 'Query', getDetectionDestinationTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null, getDetectionSourceTimelineSummary?: { __typename?: 'DetectionAlertGroupCountSummary', row_count?: number | null, summary?: Array<{ __typename?: 'DetectionAlertGroupSummary', alert_name?: string | null, entity_name?: string | null, severity?: number | null, tenant?: string | null, detections?: Array<{ __typename?: 'DetectionAlertSummary', severity?: number | null, alert_name?: string | null, entity_name?: string | null, detection_id?: string | null, latest_start_timestamp?: number | null, earliest_start_timestamp?: number | null, buckets?: Array<{ __typename?: 'DetectionAlertBucketSummary', alert_count?: number | null, bucket_end?: number | null, bucket_start?: number | null, score?: number | null } | null> | null } | null> | null } | null> | null } | null };

export type GetUserSigninHistoryQueryVariables = Exact<{
  input: EntraSigninHistorySearchInput;
  provider_name: EdrConfigurationType;
}>;


export type GetUserSigninHistoryQuery = { __typename?: 'Query', getUserSigninHistory?: { __typename?: 'EntraSigninHistoryResult', offset?: number | null, size?: number | null, total_items?: number | null, items?: Array<{ __typename?: 'EntraSigninWithUser', signin?: { __typename?: 'EntraSigninHistoryDoc', tenant?: string | null, timestamp?: number | null, microsoft_entra_id?: { __typename?: 'EntraSigninHistoryPayload', user_id?: string | null, user_principal_name?: string | null, raw?: string | null, sign_in?: { __typename?: 'EntraSigninEvent', event_id?: string | null, created_date_time?: string | null, created_date_time_epoch?: number | null, external_ip?: string | null, application_display_name?: string | null, client_app_used?: string | null, conditional_access_status?: string | null, risk_level_aggregated?: string | null, risk_level_during_signin?: string | null, status?: { __typename?: 'EntraSigninStatus', errorCode?: number | null, failureReason?: string | null, additionalDetails?: string | null } | null, location?: { __typename?: 'EntraLocation', city?: string | null, state?: string | null, country_or_region?: string | null } | null, device_detail?: { __typename?: 'EntraDeviceDetail', device_id?: string | null, display_name?: string | null, operating_system?: string | null, is_compliant?: boolean | null, is_managed?: boolean | null } | null } | null, metadata?: { __typename?: 'EntraDocMetadata', last_refreshed_at?: number | null, source?: string | null } | null } | null } | null, user?: { __typename?: 'EntraIdentityUserDoc', tenant?: string | null, timestamp?: number | null, microsoft_entra_id?: { __typename?: 'EntraIdentityUserPayload', id?: string | null, user_principal_name?: string | null, display_name?: string | null, given_name?: string | null, surname?: string | null, mail?: string | null, job_title?: string | null, department?: string | null, office_location?: string | null, business_phones?: Array<string | null> | null, mobile_phone?: string | null, account_enabled?: boolean | null, risk_level?: string | null, ADGroup?: Array<string | null> | null, raw?: string | null } | null } | null } | null> | null } | null };

export type GetIncidentsForUserQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  provider: EdrConfigurationType;
}>;


export type GetIncidentsForUserQuery = { __typename?: 'Query', getIdentityIncidentsByUser?: Array<{ __typename?: 'IdentityIncident', id?: string | null, timestamp?: number | null, incident?: { __typename?: 'CrowdStrikeIncidentDetail', incident_id?: string | null, type?: string | null, severity?: string | null, start_time?: number | null, end_time?: number | null, compromised_entities?: Array<{ __typename?: 'CompromisedEntity', entity_id?: string | null, primary_display_name?: string | null, type?: string | null } | null> | null, timeline?: Array<{ __typename?: 'TimelineEvent', event_type?: string | null, timestamp?: number | null, alert_type?: string | null, alert_id?: string | null, pattern_id?: number | null, entities?: Array<{ __typename?: 'TimelineEventEntity', primary_display_name?: string | null } | null> | null } | null> | null } | null } | null> | null };

export type GetNicHistoryForEndpointDeviceEntityQueryVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
  as_of?: InputMaybe<Scalars['Float']['input']>;
  entity?: InputMaybe<EntityIdInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  max_results?: InputMaybe<Scalars['Int']['input']>;
  use_cache?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetNicHistoryForEndpointDeviceEntityQuery = { __typename?: 'Query', getNicHistoryForEndpointDeviceEntity?: { __typename?: 'PaginatedNICHistory', as_of?: number | null, max_results?: number | null, offset?: number | null, size?: number | null, total_items?: number | null, use_cache?: boolean | null, nic_histories?: Array<{ __typename?: 'NICHistory', data_source?: string | null, ip_address?: string | null, mac_address?: string | null, obsts?: number | null } | null> | null } | null };

export type GetTriageEvidenceDetailsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
  evidence: EvidenceInput;
}>;


export type GetTriageEvidenceDetailsQuery = { __typename?: 'Query', getTriageEvidenceDetails?: { __typename?: 'TriageEvidenceDetails', evidence: string, message: string, pivot_query?: string | null, truncated: boolean } | null };

export type GetUserHistoryForEndpointDeviceEntityQueryVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
  as_of?: InputMaybe<Scalars['Float']['input']>;
  entity?: InputMaybe<EntityIdInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  max_results?: InputMaybe<Scalars['Int']['input']>;
  use_cache?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type GetUserHistoryForEndpointDeviceEntityQuery = { __typename?: 'Query', getUserHistoryForEndpointDeviceEntity?: { __typename?: 'PaginatedUserHistory', as_of?: number | null, max_results?: number | null, offset?: number | null, size?: number | null, total_items?: number | null, use_cache?: boolean | null, user_histories?: Array<{ __typename?: 'UserHistory', data_source?: string | null, obsts?: number | null, username?: string | null, identity_user?: { __typename?: 'CrowdStrikeIdentityUserInfo', user_id?: string | null, display_name?: string | null, email?: string | null, risk_score?: number | null, risk_score_severity?: string | null, identity_alerts_count?: number | null } | null } | null> | null } | null };

export type PerformEdrActionMutationVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
  action: EntityAction;
  edr_device_input: EdrDeviceInput;
}>;


export type PerformEdrActionMutation = { __typename?: 'Mutation', performEdrAction?: { __typename?: 'EntityEdrStatusWithTimestampExt', device_id?: string | null, edr_provider?: string | null, entity_edr_status?: EntityEdrStatus | null, hostname?: string | null, updated_timestamp?: number | null } | null };

export type PullEntityEdrStatusMutationVariables = Exact<{
  entity_id: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type PullEntityEdrStatusMutation = { __typename?: 'Mutation', pullEntityEdrStatus?: { __typename?: 'EntityEdrStatusWithTimestamp', tenant?: string | null, entity_edr_status?: EntityEdrStatus | null, updated_timestamp?: number | null } | null };

export type DeleteEscalationConfigurationsMutationVariables = Exact<{
  escalation_configuration_ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteEscalationConfigurationsMutation = { __typename?: 'Mutation', deleteEscalationConfigurations?: Array<{ __typename?: 'ServiceNowEscalationConfiguration', username?: string | null, password?: string | null, enabled: boolean, escalation_configuration_id: string, instance_name?: string | null, service_name: ServiceNameEnum, table_name?: string | null } | null> | null };

export type DeleteExporterMutationVariables = Exact<{
  exporter_id: ExporterIdInput;
}>;


export type DeleteExporterMutation = { __typename?: 'Mutation', deleteExporter?: boolean | null };

export type EscalateDetectionsMutationVariables = Exact<{
  escalate_detections_info: Array<EscalateDetectionInput> | EscalateDetectionInput;
}>;


export type EscalateDetectionsMutation = { __typename?: 'Mutation', escalateDetections?: Array<{ __typename?: 'EscalatedDetection', detection_id: string, escalated: boolean, escalation_configuration_id: string, message?: string | null } | null> | null };

export type GetExportersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExportersQuery = { __typename?: 'Query', getExporters?: Array<{ __typename?: 'ElasticsearchExporter', endpoint: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, auth?: { __typename?: 'ElasticsearchExporterAuth', password: string, user: string } | null, bulk: { __typename?: 'ElasticsearchBulk', index: string }, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename?: 'GenericExporter', name: string, enabled: boolean, exporter: ExporterType, exporter_id: string } | { __typename?: 'HttpExporter', uri: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, http_auth?: { __typename?: 'HttpExporterAuth', strategy: HttpAuthStrategy, basic?: { __typename?: 'HttpExporterAuthBasic', username: string, password: string } | null, bearer?: { __typename?: 'HttpExporterAuthBearer', token: string } | null } | null, headers?: Array<{ __typename?: 'HttpExporterHeader', name: string, value: string }> | null, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename: 'LogscaleExporter', tenant: string, url: string, token?: string | null, index?: string | null, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename?: 'SplunkHecLogsExporter', hec_url: string, index?: string | null, tenant: string, token?: string | null, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } }> | null };

export type GetExportersPublicQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExportersPublicQuery = { __typename?: 'Query', getExporters?: Array<{ __typename?: 'ElasticsearchExporter', endpoint: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, bulk: { __typename?: 'ElasticsearchBulk', index: string }, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename?: 'GenericExporter', name: string, enabled: boolean, exporter: ExporterType, exporter_id: string } | { __typename?: 'HttpExporter', uri: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, headers?: Array<{ __typename?: 'HttpExporterHeader', name: string, value: string }> | null, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename: 'LogscaleExporter', tenant: string, url: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename?: 'SplunkHecLogsExporter', hec_url: string, tenant: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } }> | null };

export type QueryEscalationConfigurationsQueryVariables = Exact<{
  filter?: InputMaybe<EscalationConfigurationFilterInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortingParameterInput>> | InputMaybe<SortingParameterInput>>;
}>;


export type QueryEscalationConfigurationsQuery = { __typename?: 'Query', queryEscalationConfigurations?: { __typename?: 'PaginatedEscalationConfigurations', offset?: number | null, size?: number | null, total_items?: number | null, escalation_configurations?: Array<{ __typename?: 'ServiceNowEscalationConfiguration', username?: string | null, password?: string | null, enabled: boolean, escalation_configuration_id: string, instance_name?: string | null, service_name: ServiceNameEnum, table_name?: string | null } | null> | null, filter?: { __typename?: 'EscalationConfigurationFilter', enabled?: boolean | null, escalation_configuration_ids?: Array<string | null> | null, service_names?: Array<ServiceNameEnum | null> | null } | null, sort?: Array<{ __typename?: 'SortingParameter', sort_by: SortByEnum, sort_dir: SortDirEnum } | null> | null } | null };

export type QueryEscalationConfigurationsPublicQueryVariables = Exact<{
  tenant?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EscalationConfigurationFilterInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortingParameterInput>> | InputMaybe<SortingParameterInput>>;
}>;


export type QueryEscalationConfigurationsPublicQuery = { __typename?: 'Query', queryEscalationConfigurations?: { __typename?: 'PaginatedEscalationConfigurations', offset?: number | null, size?: number | null, total_items?: number | null, escalation_configurations?: Array<{ __typename?: 'ServiceNowEscalationConfiguration', enabled: boolean, escalation_configuration_id: string, service_name: ServiceNameEnum } | null> | null, filter?: { __typename?: 'EscalationConfigurationFilter', enabled?: boolean | null, escalation_configuration_ids?: Array<string | null> | null, service_names?: Array<ServiceNameEnum | null> | null } | null, sort?: Array<{ __typename?: 'SortingParameter', sort_by: SortByEnum, sort_dir: SortDirEnum } | null> | null } | null };

export type SaveEscalationConfigurationsMutationVariables = Exact<{
  escalation_configurations: Array<EscalationConfigurationInput> | EscalationConfigurationInput;
}>;


export type SaveEscalationConfigurationsMutation = { __typename?: 'Mutation', saveEscalationConfigurations?: Array<{ __typename?: 'ServiceNowEscalationConfiguration', username?: string | null, password?: string | null, enabled: boolean, escalation_configuration_id: string, instance_name?: string | null, service_name: ServiceNameEnum, table_name?: string | null } | null> | null };

export type SaveExporterMutationVariables = Exact<{
  input: ExporterInput;
}>;


export type SaveExporterMutation = { __typename?: 'Mutation', saveExporter?: { __typename?: 'ElasticsearchExporter', endpoint: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean }, auth?: { __typename?: 'ElasticsearchExporterAuth', password: string, user: string } | null, bulk: { __typename?: 'ElasticsearchBulk', index: string } } | { __typename?: 'GenericExporter', name: string, enabled: boolean, exporter: ExporterType, exporter_id: string } | { __typename?: 'HttpExporter', uri: string, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, http_auth?: { __typename?: 'HttpExporterAuth', strategy: HttpAuthStrategy, basic?: { __typename?: 'HttpExporterAuthBasic', username: string, password: string } | null, bearer?: { __typename?: 'HttpExporterAuthBearer', token: string } | null } | null, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean }, headers?: Array<{ __typename?: 'HttpExporterHeader', name: string, value: string }> | null } | { __typename: 'LogscaleExporter', tenant: string, url: string, token?: string | null, index?: string | null, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | { __typename?: 'SplunkHecLogsExporter', hec_url: string, index?: string | null, tenant: string, token?: string | null, name: string, enabled: boolean, exporter: ExporterType, exporter_id: string, tls: { __typename?: 'ExporterTLSInfo', verify_certificate: boolean } } | null };

export type VerifyEscalationConfigurationQueryVariables = Exact<{
  escalation_configuration: EscalationConfigurationInput;
}>;


export type VerifyEscalationConfigurationQuery = { __typename?: 'Query', verifyEscalationConfiguration?: { __typename?: 'VerifiedEscalationConfiguration', verified: boolean } | null };

export type CreateQueryJobMutationVariables = Exact<{
  clientSessionId: Scalars['String']['input'];
  queryInputJob: QueryInputJob;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortParameterInput>> | InputMaybe<SortParameterInput>>;
}>;


export type CreateQueryJobMutation = { __typename?: 'Mutation', createQueryJob?: { __typename?: 'CreateQueryJobResult', query_job_id?: string | null } | null };

export type GetHumioDashboardsQueryVariables = Exact<{
  humioSessionToken: Scalars['String']['input'];
}>;


export type GetHumioDashboardsQuery = { __typename?: 'Query', getHumioDashboards?: { __typename?: 'HumioDomainOutput', searchDomain?: { __typename?: 'HumioTenant', dashboards?: Array<{ __typename?: 'Dashboard', name?: string | null, id?: string | null } | null> | null } | null } | null };

export type PollQueryJobQueryVariables = Exact<{
  clientSessionId: Scalars['String']['input'];
  queryJobId: Scalars['String']['input'];
}>;


export type PollQueryJobQuery = { __typename?: 'Query', pollQueryJob?: { __typename?: 'QueryJobResult', cancelled?: boolean | null, done?: boolean | null, events?: Array<string | null> | null } | null };

export type SimpleSearchQueryQueryVariables = Exact<{
  clientSessionId: Scalars['String']['input'];
  queryString: Scalars['String']['input'];
  end: Scalars['String']['input'];
  ingestEnd?: InputMaybe<Scalars['String']['input']>;
  ingestStart?: InputMaybe<Scalars['String']['input']>;
  languageVersion?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['String']['input'];
  timeZoneOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  tenantsForQuery?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SimpleSearchQueryQuery = { __typename?: 'Query', simpleSearchQuery?: { __typename?: 'SimpleQueryJobResult', events?: Array<string | null> | null, total_items?: number | null, size?: number | null } | null };

export type AcceptEulaTcMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptEulaTcMutation = { __typename?: 'Mutation', acceptEulaTC?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', message?: string | null, data?: any | null } | null } | null };

export type AcceptHumioTcMutationVariables = Exact<{
  humioSessionToken: Scalars['String']['input'];
}>;


export type AcceptHumioTcMutation = { __typename?: 'Mutation', acceptHumioTC?: { __typename?: 'SuccessOutput', status_code?: number | null, body?: { __typename?: 'SuccessBody', data?: string | null, message?: string | null, success?: boolean | null } | null } | null };

export type ActivateUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivateUserAccountMutation = { __typename?: 'Mutation', activateUserAccount?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type GetAppConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppConfigurationsQuery = { __typename?: 'Query', getAppConfigurations?: { __typename?: 'SuccessOutput', status_code?: number | null, body?: { __typename?: 'SuccessBody', data?: string | null, message?: string | null, success?: boolean | null } | null } | null };

export type GetUserCookieAcceptanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCookieAcceptanceQuery = { __typename?: 'Query', getUserCookieAcceptance?: Array<{ __typename?: 'UserCookieStatus', cookie_type?: CookieType | null, cookies_accepted?: boolean | null, cookies_accepted_expiration?: number | null } | null> | null };

export type GetUserLogsQueryVariables = Exact<{
  input: GetUserLogsInput;
}>;


export type GetUserLogsQuery = { __typename?: 'Query', getUserLogs?: { __typename?: 'UserLogs', offset?: number | null, size?: number | null, total_items?: number | null, log?: Array<{ __typename?: 'UserLog', message?: any | null, timestamp?: string | null, tenant?: string | null, tenant_info?: { __typename?: 'UsersTenantInfo', tenant_id?: string | null, tenant_display_name?: string | null } | null } | null> | null } | null };

export type GetUserTcAcceptanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTcAcceptanceQuery = { __typename?: 'Query', getUserTcAcceptance?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type GetPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrivilegesQuery = { __typename?: 'Query', getPrivileges?: any | null };

export type LogOperationMutationVariables = Exact<{
  input: LogOperationInput;
}>;


export type LogOperationMutation = { __typename?: 'Mutation', logOperation?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', data?: any | null, message?: string | null, success?: boolean | null } | null } | null };

export type UserUpdateCookieStatusMutationVariables = Exact<{
  updates?: InputMaybe<Array<InputMaybe<UpdateUserCookieStatusInput>> | InputMaybe<UpdateUserCookieStatusInput>>;
}>;


export type UserUpdateCookieStatusMutation = { __typename?: 'Mutation', userUpdateCookieStatus?: { __typename?: 'UserSuccessOutput', status_code?: number | null, body?: { __typename?: 'UserSuccessBody', message?: string | null, success?: boolean | null } | null } | null };
